"use strict";

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e,
    r = require("pdfjs-dist"),
    a = require("react-dom"),
    o = n.createContext({
  prefixClass: "viewer"
}),
    i = function i(e) {
  var t = [];
  return Object.keys(e).forEach(function (n) {
    n && e[n] && t.push(n);
  }), t.join(" ");
},
    l = function l(e) {
  var r,
      a = e.children,
      l = e.isSelected,
      c = void 0 !== l && l,
      s = e.onClick,
      u = t.useContext(o);
  return n.createElement("button", {
    className: i((r = {}, r[u.prefixClass + "-button"] = !0, r[u.prefixClass + "-button-selected"] = c, r)),
    onClick: s
  }, a);
},
    c = function c() {
  var e = t.useContext(o);
  return n.createElement("li", {
    className: e.prefixClass + "-menu-divider"
  });
},
    s = function s(e) {
  var r = e.children,
      a = e.size,
      i = void 0 === a ? 24 : a,
      l = t.useContext(o),
      c = (i || 24) + "px";
  return n.createElement("svg", {
    className: l.prefixClass + "-icon",
    height: c,
    viewBox: "0 0 24 24",
    width: c
  }, r);
},
    u = function u() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M23.5,0.499l-16.5,23l-6.5-6.5"
  }));
},
    p = function p(e) {
  var r = e.checked,
      a = void 0 !== r && r,
      i = e.children,
      l = e.icon,
      c = void 0 === l ? null : l,
      s = e.onClick,
      p = t.useContext(o);
  return n.createElement("li", {
    className: p.prefixClass + "-menu-item",
    onClick: s
  }, n.createElement("div", {
    className: p.prefixClass + "-menu-item-icon"
  }, c), n.createElement("div", {
    className: p.prefixClass + "-menu-item-label"
  }, i), n.createElement("div", {
    className: p.prefixClass + "-menu-item-check"
  }, a && n.createElement(u, null)));
},
    m = function m(e) {
  var r = e.children,
      a = e.onClick,
      i = t.useContext(o);
  return n.createElement("button", {
    className: i.prefixClass + "-primary-button",
    onClick: a
  }, r);
},
    f = function f(e) {
  var r = e.progress,
      a = t.useContext(o);
  return n.createElement("div", {
    className: a.prefixClass + "-progress-bar"
  }, n.createElement("div", {
    className: a.prefixClass + "-progress-bar-inner",
    style: {
      width: r + "%"
    }
  }, r, "%"));
},
    d = function d() {
  var e = t.useContext(o);
  return n.createElement("div", {
    className: e.prefixClass + "-separator"
  });
},
    g = function g() {
  var e = t.useContext(o);
  return n.createElement("svg", {
    className: e.prefixClass + "-spinner",
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32"
  }, n.createElement("circle", {
    className: e.prefixClass + "-spinner-circle",
    cx: "16",
    cy: "16",
    r: "12",
    strokeDasharray: 2 * Math.PI * 9
  }));
},
    _h = function h(e, t) {
  return (_h = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      t.hasOwnProperty(n) && (e[n] = t[n]);
    }
  })(e, t);
};

function v(e, t) {
  function n() {
    this.constructor = e;
  }

  _h(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var E,
    _C = function C() {
  return (_C = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var a in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    x = function x(e, r, a, l, c) {
  var s,
      u = t.useContext(o);
  return n.createElement("div", _C({}, r.attrs, {
    className: i((s = {}, s[u.prefixClass + "-layout-container"] = !0, s[u.prefixClass + "-layout-with-sidebar"] = e, s)),
    style: r.attrs.style
  }), r.children, n.createElement("div", {
    className: u.prefixClass + "-layout-toolbar"
  }, l), n.createElement("div", {
    className: u.prefixClass + "-layout-sidebar"
  }, c.children), n.createElement("div", _C({}, a.attrs, {
    className: u.prefixClass + "-layout-main",
    style: a.attrs.style
  }), a.children));
},
    b = function b(e) {
  var r = t.useContext(o);
  return n.createElement("div", {
    className: r.prefixClass + "-toolbar"
  }, n.createElement("div", {
    className: r.prefixClass + "-toolbar-left"
  }, n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.toggleSidebarButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.searchPopover), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.previousPageButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.currentPageInput, " / ", e.numPages), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.nextPageButton)), n.createElement("div", {
    className: r.prefixClass + "-toolbar-center"
  }, n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.zoomOutButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.zoomPopover), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.zoomInButton)), n.createElement("div", {
    className: r.prefixClass + "-toolbar-right"
  }, n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.fullScreenButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.openFileButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.downloadButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.printButton), n.createElement("div", {
    className: r.prefixClass + "-toolbar-item"
  }, e.moreActionsPopover)));
},
    w = function w(e, n, r) {
  var a = function a(e) {
    var t = n.current;
    t && !t.contains(e.target) && r();
  };

  t.useEffect(function () {
    if (e) return document.addEventListener("click", a), function () {
      document.removeEventListener("click", a);
    };
  }, []);
},
    k = function k(e, n) {
  var r = function r(t) {
    t.keyCode === e && n();
  };

  t.useEffect(function () {
    return document.addEventListener("keyup", r), function () {
      document.removeEventListener("keyup", r);
    };
  }, []);
},
    y = function y(e) {
  var r = e.children,
      a = e.closeOnClickOutside,
      i = e.closeOnEscape,
      l = e.onToggle,
      c = t.useContext(o),
      s = t.createRef();
  return t.useEffect(function () {
    var e = window.getComputedStyle(document.body).overflow;
    return document.body.style.overflow = "hidden", function () {
      document.body.style.overflow = e;
    };
  }, []), k(27, function () {
    return i && l();
  }), w(a, s, l), n.createElement("div", {
    className: c.prefixClass + "-modal-body",
    ref: s
  }, r);
},
    P = function P(e) {
  var r = e.children,
      a = t.useContext(o);
  return n.createElement("div", {
    className: a.prefixClass + "-modal-overlay"
  }, r);
};

!function (e) {
  e.Close = "Close", e.Open = "Open", e.Toggle = "Toggle";
}(E || (E = {}));

var S,
    M = function M() {
  var e = t.useState(!1),
      n = e[0],
      r = e[1];
  return {
    opened: n,
    toggle: function toggle(e) {
      switch (e) {
        case E.Close:
          r(!1);
          break;

        case E.Open:
          r(!0);
          break;

        case E.Toggle:
        default:
          r(function (e) {
            return !e;
          });
      }
    }
  };
},
    L = function L(e) {
  var t = e.content,
      r = e.target,
      a = M(),
      o = a.opened,
      i = a.toggle;
  return n.createElement(n.Fragment, null, r(i, o), o && t(i));
},
    T = function T(e) {
  var t = e.closeOnClickOutside,
      r = e.closeOnEscape,
      a = e.content,
      o = e.target;
  return n.createElement(L, {
    target: o,
    content: function content(e) {
      return n.createElement(P, null, n.createElement(y, {
        closeOnClickOutside: t,
        closeOnEscape: r,
        onToggle: e
      }, a(e)));
    }
  });
};

!function (e) {
  e.TopLeft = "TOP_LEFT", e.TopCenter = "TOP_CENTER", e.TopRight = "TOP_RIGHT", e.RightTop = "RIGHT_TOP", e.RightCenter = "RIGHT_CENTER", e.RightBottom = "RIGHT_BOTTOM", e.BottomLeft = "BOTTOM_LEFT", e.BottomCenter = "BOTTOM_CENTER", e.BottomRight = "BOTTOM_RIGHT", e.LeftTop = "LEFT_TOP", e.LeftCenter = "LEFT_CENTER", e.LeftBottom = "LEFT_BOTTOM";
}(S || (S = {}));

var N,
    R = S,
    O = function O(e, n, r, a, o) {
  t.useLayoutEffect(function () {
    var t = n.current,
        i = e.current,
        l = r.current;

    if (i && t && l) {
      var c = l.getBoundingClientRect(),
          s = function (e, t, n, r) {
        var a = t.getBoundingClientRect(),
            o = e.getBoundingClientRect(),
            i = o.height,
            l = o.width,
            c = 0,
            s = 0;

        switch (n) {
          case R.TopLeft:
            c = a.top - i, s = a.left;
            break;

          case R.TopCenter:
            c = a.top - i, s = a.left + a.width / 2 - l / 2;
            break;

          case R.TopRight:
            c = a.top - i, s = a.left + a.width - l;
            break;

          case R.RightTop:
            c = a.top, s = a.left + a.width;
            break;

          case R.RightCenter:
            c = a.top + a.height / 2 - i / 2, s = a.left + a.width;
            break;

          case R.RightBottom:
            c = a.top + a.height - i, s = a.left + a.width;
            break;

          case R.BottomLeft:
            c = a.top + a.height, s = a.left;
            break;

          case R.BottomCenter:
            c = a.top + a.height, s = a.left + a.width / 2 - l / 2;
            break;

          case R.BottomRight:
            c = a.top + a.height, s = a.left + a.width - l;
            break;

          case R.LeftTop:
            c = a.top, s = a.left - l;
            break;

          case R.LeftCenter:
            c = a.top + a.height / 2 - i / 2, s = a.left - l;
            break;

          case R.LeftBottom:
            c = a.top + a.height - i, s = a.left - l;
        }

        return {
          left: s + (r.left || 0),
          top: c + (r.top || 0)
        };
      }(i, t, a, o),
          u = s.top,
          p = s.left;

      i.style.top = u - c.top + "px", i.style.left = p - c.left + "px";
    }
  }, []);
},
    F = function F(e) {
  var r,
      a = e.customClassName,
      l = e.position,
      c = t.useContext(o);
  return n.createElement("div", {
    className: i((r = {}, r[c.prefixClass + "-arrow"] = !0, r[c.prefixClass + "-arrow-tl"] = l === R.TopLeft, r[c.prefixClass + "-arrow-tc"] = l === R.TopCenter, r[c.prefixClass + "-arrow-tr"] = l === R.TopRight, r[c.prefixClass + "-arrow-rt"] = l === R.RightTop, r[c.prefixClass + "-arrow-rc"] = l === R.RightCenter, r[c.prefixClass + "-arrow-rb"] = l === R.RightBottom, r[c.prefixClass + "-arrow-bl"] = l === R.BottomLeft, r[c.prefixClass + "-arrow-bc"] = l === R.BottomCenter, r[c.prefixClass + "-arrow-br"] = l === R.BottomRight, r[c.prefixClass + "-arrow-lt"] = l === R.LeftTop, r[c.prefixClass + "-arrow-lc"] = l === R.LeftCenter, r[c.prefixClass + "-arrow-lb"] = l === R.LeftBottom, r["" + a] = "" !== a, r))
  });
},
    B = function B(e) {
  var r = e.children,
      a = e.closeOnClickOutside,
      i = e.offset,
      l = e.position,
      c = e.targetRef,
      s = e.onClose,
      u = t.useContext(o),
      p = t.createRef(),
      m = t.createRef();
  return w(a, p, s), O(p, c, m, l, i), n.createElement(n.Fragment, null, n.createElement("div", {
    ref: m,
    style: {
      left: 0,
      position: "absolute",
      top: 0
    }
  }), n.createElement("div", {
    className: u.prefixClass + "-popover-body",
    ref: p
  }, n.createElement(F, {
    customClassName: u.prefixClass + "-popover-body-arrow",
    position: l
  }), r));
},
    z = function z(e) {
  var r = e.closeOnEscape,
      a = e.onClose,
      i = t.useContext(o);
  return k(27, function () {
    return r && a();
  }), n.createElement("div", {
    className: i.prefixClass + "-popover-overlay"
  });
},
    H = function H(e) {
  var t = e.closeOnClickOutside,
      r = e.closeOnEscape,
      a = e.content,
      o = e.offset,
      i = e.position,
      l = e.target,
      c = n.createRef();
  return n.createElement(L, {
    content: function content(e) {
      return n.createElement(n.Fragment, null, n.createElement(z, {
        closeOnEscape: r,
        onClose: e
      }), n.createElement(B, {
        closeOnClickOutside: t,
        offset: o,
        position: i,
        targetRef: c,
        onClose: e
      }, a(e)));
    },
    target: function target(e, t) {
      return n.createElement("div", {
        ref: c
      }, l(e, t));
    }
  });
},
    D = function D(e) {
  var r = e.children,
      a = e.offset,
      i = e.position,
      l = e.targetRef,
      c = t.useContext(o),
      s = t.createRef(),
      u = t.createRef();
  return O(s, l, u, i, a), n.createElement(n.Fragment, null, n.createElement("div", {
    ref: u,
    style: {
      left: 0,
      position: "absolute",
      top: 0
    }
  }), n.createElement("div", {
    className: c.prefixClass + "-tooltip-body",
    ref: s
  }, n.createElement(F, {
    customClassName: c.prefixClass + "-tooltip-body-arrow",
    position: i
  }), n.createElement("div", {
    className: c.prefixClass + "-tooltip-body-content"
  }, r)));
},
    A = function A(e) {
  var t = e.content,
      r = e.offset,
      a = e.position,
      o = e.target,
      i = n.createRef();
  return n.createElement(L, {
    target: function target(e) {
      return n.createElement("div", {
        ref: i,
        onMouseEnter: function onMouseEnter() {
          e(E.Open);
        },
        onMouseLeave: function onMouseLeave() {
          e(E.Close);
        }
      }, o);
    },
    content: function content() {
      return n.createElement(D, {
        offset: r,
        position: a,
        targetRef: i
      }, t());
    }
  });
};

!function (e) {
  e.Horizontal = "Horizontal", e.Vertical = "Vertical", e.Wrapped = "Wrapped";
}(N || (N = {}));
var I,
    W = N;
!function (e) {
  e[e.Hand = 0] = "Hand", e[e.Text = 1] = "Text";
}(I || (I = {}));
var V,
    J = I;
!function (e) {
  e.ActualSize = "ActualSize", e.PageFit = "PageFit", e.PageWidth = "PageWidth";
}(V || (V = {}));
var q,
    j = V;
!function (e) {
  e[e.ExitFullScreen = 0] = "ExitFullScreen", e[e.FullScreenChange = 1] = "FullScreenChange", e[e.FullScreenElement = 2] = "FullScreenElement", e[e.FullScreenEnabled = 3] = "FullScreenEnabled", e[e.RequestFullScreen = 4] = "RequestFullScreen";
}(q || (q = {}));

var _,
    U = {
  ExitFullScreen: "exitFullscreen",
  FullScreenChange: "fullscreenchange",
  FullScreenElement: "fullscreenElement",
  FullScreenEnabled: "fullscreenEnabled",
  RequestFullScreen: "requestFullscreen"
},
    Z = {
  ExitFullScreen: "webkitExitFullscreen",
  FullScreenChange: "webkitfullscreenchange",
  FullScreenElement: "webkitFullscreenElement",
  FullScreenEnabled: "webkitFullscreenEnabled",
  RequestFullScreen: "webkitRequestFullscreen"
},
    G = {
  ExitFullScreen: "msExitFullscreen",
  FullScreenChange: "MSFullscreenChange",
  FullScreenElement: "msFullscreenElement",
  FullScreenEnabled: "msFullscreenEnabled",
  RequestFullScreen: "msRequestFullscreen"
},
    K = "undefined" != typeof window,
    X = K && (q.FullScreenEnabled in document && U || Z.FullScreenEnabled in document && Z || G.FullScreenEnabled in document && G) || U,
    Y = function Y(e) {
  return K ? e[X.ExitFullScreen]() : Promise.resolve({});
},
    Q = function Q() {
  return K ? document[X.FullScreenElement] : null;
},
    $ = function $(e) {
  var n = t.useState(!1),
      r = n[0],
      a = n[1],
      o = function o() {
    var t = Q();
    a(t === e.current);
  };

  return t.useEffect(function () {
    var e;
    return e = o, K && document.addEventListener(X.FullScreenChange, e), function () {
      !function (e) {
        K && document.removeEventListener(X.FullScreenChange, e);
      }(o);
    };
  }, [e.current]), {
    closeFullScreen: function closeFullScreen() {
      var t = Q();
      r && t && t === e.current && Y(document);
    },
    isFullScreen: r,
    openFullScreen: function openFullScreen() {
      var t;
      (t = Q(), t && t !== e.current ? Y(t) : Promise.resolve()).then(function () {
        var t;
        e.current && (t = e.current, K && t[X.RequestFullScreen]());
      });
    }
  };
},
    ee = function ee(e) {
  var r = e.page,
      a = e.renderAnnotations,
      o = t.useState(!0),
      i = o[0],
      l = o[1],
      c = t.useState([]),
      s = c[0],
      u = c[1];
  return t.useEffect(function () {
    r.getAnnotations({
      intent: "display"
    }).then(function (e) {
      l(!1), u(e);
    });
  }, []), i ? n.createElement(n.Fragment, null) : a(s);
};

!function (e) {
  e[e.Text = 1] = "Text", e[e.Link = 2] = "Link", e[e.FreeText = 3] = "FreeText", e[e.Line = 4] = "Line", e[e.Square = 5] = "Square", e[e.Circle = 6] = "Circle", e[e.Polygon = 7] = "Polygon", e[e.Polyline = 8] = "Polyline", e[e.Highlight = 9] = "Highlight", e[e.Underline = 10] = "Underline", e[e.Squiggly = 11] = "Squiggly", e[e.StrikeOut = 12] = "StrikeOut", e[e.Stamp = 13] = "Stamp", e[e.Caret = 14] = "Caret", e[e.Ink = 15] = "Ink", e[e.Popup = 16] = "Popup", e[e.FileAttachment = 17] = "FileAttachment";
}(_ || (_ = {}));
var te,
    ne = _;
!function (e) {
  e[e.Solid = 1] = "Solid", e[e.Dashed = 2] = "Dashed", e[e.Beveled = 3] = "Beveled", e[e.Inset = 4] = "Inset", e[e.Underline = 5] = "Underline";
}(te || (te = {}));

var re,
    ae = te,
    oe = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"),
    ie = function ie(e, t, n, r) {
  var a = parseInt(e, 10);
  return a >= t && a <= n ? a : r;
},
    le = function le(e) {
  var t = oe.exec(e);
  if (!t) return null;
  var n = parseInt(t[1], 10),
      r = ie(t[2], 1, 12, 1) - 1,
      a = ie(t[3], 1, 31, 1),
      o = ie(t[4], 0, 23, 0),
      i = ie(t[5], 0, 59, 0),
      l = ie(t[6], 0, 59, 0),
      c = t[7] || "Z",
      s = ie(t[8], 0, 23, 0),
      u = ie(t[9], 0, 59, 0);

  switch (c) {
    case "-":
      o += s, i += u;
      break;

    case "+":
      o -= s, i -= u;
  }

  return new Date(Date.UTC(n, r, a, o, i, l));
},
    ce = function ce(e) {
  var r = e.annotation,
      a = t.useContext(o),
      i = "";

  if (r.modificationDate) {
    var l = le(r.modificationDate);
    i = l ? l.toLocaleDateString() + ", " + l.toLocaleTimeString() : "";
  }

  return n.createElement("div", {
    className: a.prefixClass + "-annotation-popup-wrapper",
    style: {
      top: r.annotationType === ne.Popup ? "" : "100%"
    }
  }, r.title && n.createElement("div", {
    className: a.prefixClass + "-annotation-popup-wrapper-header"
  }, n.createElement("div", {
    className: a.prefixClass + "-annotation-popup-wrapper-title"
  }, r.title), n.createElement("span", {
    className: a.prefixClass + "-annotation-popup-wrapper-date"
  }, i)), r.contents && n.createElement("div", {
    className: a.prefixClass + "-annotation-popup-wrapper-content"
  }, r.contents.split("\n").map(function (e, r) {
    return n.createElement(t.Fragment, {
      key: r
    }, e, n.createElement("br", null));
  })));
};

!function (e) {
  e.Click = "Click", e.Hover = "Hover";
}(re || (re = {}));

var se,
    ue = function ue(e) {
  var r,
      a = e.annotation,
      o = e.children,
      i = e.ignoreBorder,
      l = e.hasPopup,
      c = e.isRenderable,
      s = e.page,
      u = e.viewport,
      p = a.rect,
      m = function () {
    var e = M(),
        n = e.opened,
        r = e.toggle,
        a = t.useState(re.Hover),
        o = a[0],
        i = a[1];
    return {
      opened: n,
      closeOnHover: function closeOnHover() {
        o === re.Hover && r(E.Close);
      },
      openOnHover: function openOnHover() {
        o === re.Hover && r(E.Open);
      },
      toggleOnClick: function toggleOnClick() {
        switch (o) {
          case re.Click:
            n && i(re.Hover), r(E.Toggle);
            break;

          case re.Hover:
            i(re.Click), r(E.Open);
        }
      }
    };
  }(),
      f = m.closeOnHover,
      d = m.opened,
      g = m.openOnHover,
      h = m.toggleOnClick,
      v = (r = [p[0], s.view[3] + s.view[1] - p[1], p[2], s.view[3] + s.view[1] - p[3]], [Math.min(r[0], r[2]), Math.min(r[1], r[3]), Math.max(r[0], r[2]), Math.max(r[1], r[3])]),
      C = p[2] - p[0],
      x = p[3] - p[1],
      b = {
    borderColor: "",
    borderRadius: "",
    borderStyle: "",
    borderWidth: ""
  };

  if (!i && a.borderStyle.width > 0) {
    switch (a.borderStyle.style) {
      case ae.Dashed:
        b.borderStyle = "dashed";
        break;

      case ae.Solid:
        b.borderStyle = "solid";
        break;

      case ae.Underline:
        b = Object.assign({
          borderBottomStyle: "solid"
        }, b);
        break;

      case ae.Beveled:
      case ae.Inset:
    }

    var w = a.borderStyle.width;
    b.borderWidth = w + "px", a.borderStyle.style !== ae.Underline && (C -= 2 * w, x -= 2 * w);
    var k = a.borderStyle,
        y = k.horizontalCornerRadius,
        P = k.verticalCornerRadius;
    (y > 0 || P > 0) && (b.borderRadius = y + "px / " + P + "px"), a.color ? b.borderColor = "rgb(" + (0 | a.color[0]) + ", " + (0 | a.color[1]) + ", " + (0 | a.color[2]) + ")" : b.borderWidth = "0";
  }

  return n.createElement(n.Fragment, null, c && o({
    popup: {
      opened: d,
      closeOnHover: f,
      openOnHover: g,
      toggleOnClick: h
    },
    slot: {
      attrs: {
        style: Object.assign({
          height: x + "px",
          left: v[0] + "px",
          top: v[1] + "px",
          transform: "matrix(" + u.transform.join(",") + ")",
          transformOrigin: "-" + v[0] + "px -" + v[1] + "px",
          width: C + "px"
        }, b)
      },
      children: n.createElement(n.Fragment, null, l && d && n.createElement(ce, {
        annotation: a
      }))
    }
  }));
},
    pe = function pe(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-caret",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    me = function me(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-circle",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, n.createElement("circle", {
      cy: m / 2,
      fill: "none",
      rx: p / 2 - f / 2,
      ry: m / 2 - f / 2,
      stroke: "transparent",
      strokeWidth: f || 1
    })), e.slot.children);
  });
},
    fe = function fe(e) {
  var t = e.split("/").pop();
  return t ? t.split("#")[0].split("?")[0] : e;
},
    de = function de(e, t) {
  var n = "string" == typeof t ? "" : URL.createObjectURL(new Blob([t], {
    type: ""
  })),
      r = document.createElement("a");
  r.style.display = "none", r.href = n || e, r.setAttribute("download", fe(e)), document.body.appendChild(r), r.click(), document.body.removeChild(r), n && URL.revokeObjectURL(n);
},
    ge = function ge(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !(!1 !== r.hasPopup || !r.title && !r.contents),
      s = function s() {
    var e = r.file;
    e && de(e.filename, e.content);
  };

  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: !0,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-file-attachment",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onDoubleClick: s,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    he = function he(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-free-text",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    ve = function ve(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-highlight",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    Ee = function Ee(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-ink",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), r.inkLists && r.inkLists.length && n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, r.inkLists.map(function (e, t) {
      return n.createElement("polyline", {
        key: t,
        fill: "none",
        stroke: "transparent",
        strokeWidth: f || 1,
        points: e.map(function (e) {
          return e.x - u[0] + "," + (u[3] - e.y);
        }).join(" ")
      });
    })), e.slot.children);
  });
},
    Ce = function Ce(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-line",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, n.createElement("line", {
      stroke: "transparent",
      strokeWidth: f || 1,
      x1: u[2] - r.lineCoordinates[0],
      x2: u[2] - r.lineCoordinates[2],
      y1: u[3] - r.lineCoordinates[1],
      y2: u[3] - r.lineCoordinates[3]
    })), e.slot.children);
  });
},
    xe = function xe(e, t) {
  return new Promise(function (n) {
    new Promise(function (n) {
      "string" == typeof t ? e.getDestination(t).then(function (e) {
        n(e);
      }) : n(t);
    }).then(function (t) {
      e.getPageIndex(t[0]).then(function (e) {
        var r = function (e, t) {
          switch (t[1].name) {
            case "XYZ":
              return {
                bottomOffset: t[3],
                pageIndex: e - 1,
                scaleTo: t[4]
              };

            case "Fit":
              return {
                bottomOffset: 0,
                pageIndex: e - 1,
                scaleTo: j.PageFit
              };

            default:
              return {
                bottomOffset: 0,
                pageIndex: e - 1,
                scaleTo: 1
              };
          }
        }(e, t);

        n(r);
      });
    });
  });
},
    be = function be(e) {
  var r = e.annotation,
      a = e.doc,
      i = e.page,
      l = e.viewport,
      c = e.onExecuteNamedAction,
      s = e.onJumpToDest,
      u = t.useContext(o),
      p = !!(r.url || r.dest || r.action),
      m = r.url ? {
    href: r.url,
    rel: "noopener noreferrer nofollow",
    target: r.newWindow ? "_blank" : "",
    title: r.url
  } : {
    href: "",
    onClick: function onClick(e) {
      e.preventDefault(), r.action ? c(r.action) : xe(a, r.dest).then(function (e) {
        var t = e.pageIndex,
            n = e.bottomOffset,
            r = e.scaleTo;
        s(t + 1, n, r);
      });
    }
  };
  return n.createElement(ue, {
    annotation: r,
    hasPopup: !1,
    ignoreBorder: !1,
    isRenderable: p,
    page: i,
    viewport: l
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: u.prefixClass + "-annotation " + u.prefixClass + "-annotation-link",
      "data-annotation-id": r.id
    }), n.createElement("a", _C({}, m)));
  });
},
    we = function we(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-polygon",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), r.vertices && r.vertices.length && n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, n.createElement("polygon", {
      fill: "none",
      stroke: "transparent",
      strokeWidth: f || 1,
      points: r.vertices.map(function (e) {
        return e.x - u[0] + "," + (u[3] - e.y);
      }).join(" ")
    })), e.slot.children);
  });
},
    ke = function ke(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-polyline",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), r.vertices && r.vertices.length && n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, n.createElement("polyline", {
      fill: "none",
      stroke: "transparent",
      strokeWidth: f || 1,
      points: r.vertices.map(function (e) {
        return e.x - u[0] + "," + (u[3] - e.y);
      }).join(" ")
    })), e.slot.children);
  });
},
    ye = function ye(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !(!r.title && !r.contents),
      s = !r.parentType || -1 !== ["Circle", "Ink", "Line", "Polygon", "PolyLine", "Square"].indexOf(r.parentType);
  return t.useLayoutEffect(function () {
    if (r.parentId) {
      var e = document.querySelector('[data-annotation-id="' + r.parentId + '"]'),
          t = document.querySelector('[data-annotation-id="' + r.id + '"]');

      if (e && t) {
        var n = parseFloat(e.style.left),
            a = parseFloat(e.style.top) + parseFloat(e.style.height);
        t.style.left = n + "px", t.style.top = a + "px", t.style.transformOrigin = "-" + n + "px -" + a + "px";
      }
    }
  }, []), n.createElement(ue, {
    annotation: r,
    hasPopup: s,
    ignoreBorder: !1,
    isRenderable: c,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-popup",
      "data-annotation-id": r.id
    }), n.createElement(ce, {
      annotation: r
    }));
  });
},
    Pe = function Pe(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents),
      u = r.rect,
      p = u[2] - u[0],
      m = u[3] - u[1],
      f = r.borderStyle.width;
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-square",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), n.createElement("svg", {
      height: m + "px",
      preserveAspectRatio: "none",
      version: "1.1",
      viewBox: "0 0 " + p + " " + m,
      width: p + "px"
    }, n.createElement("rect", {
      height: m - f,
      fill: "none",
      stroke: "transparent",
      strokeWidth: f || 1,
      x: f / 2,
      y: f / 2,
      width: p - f
    })), e.slot.children);
  });
},
    Se = function Se(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-squiggly",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    Me = function Me(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-stamp",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    Le = function Le(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-strike-out",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    Te = function Te() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M.5,16.5a1,1,0,0,0,1,1h2v4l4-4h15a1,1,0,0,0,1-1V3.5a1,1,0,0,0-1-1H1.5a1,1,0,0,0-1,1Z"
  }), n.createElement("path", {
    d: "M7.25,9.75A.25.25,0,1,1,7,10a.25.25,0,0,1,.25-.25"
  }), n.createElement("path", {
    d: "M12,9.75a.25.25,0,1,1-.25.25A.25.25,0,0,1,12,9.75"
  }), n.createElement("path", {
    d: "M16.75,9.75a.25.25,0,1,1-.25.25.25.25,0,0,1,.25-.25"
  }));
},
    Ne = function Ne() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M0.500 12.001 A11.500 11.500 0 1 0 23.500 12.001 A11.500 11.500 0 1 0 0.500 12.001 Z"
  }), n.createElement("path", {
    d: "M6.000 12.001 A6.000 6.000 0 1 0 18.000 12.001 A6.000 6.000 0 1 0 6.000 12.001 Z"
  }), n.createElement("path", {
    d: "M21.423 5.406L17.415 9.414"
  }), n.createElement("path", {
    d: "M14.587 6.585L18.607 2.565"
  }), n.createElement("path", {
    d: "M5.405 21.424L9.413 17.416"
  }), n.createElement("path", {
    d: "M6.585 14.588L2.577 18.596"
  }), n.createElement("path", {
    d: "M18.602 21.419L14.595 17.412"
  }), n.createElement("path", {
    d: "M17.419 14.58L21.428 18.589"
  }), n.createElement("path", {
    d: "M2.582 5.399L6.588 9.406"
  }), n.createElement("path", {
    d: "M9.421 6.581L5.412 2.572"
  }));
},
    Re = function Re() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M4.000 18.500 A1.500 1.500 0 1 0 7.000 18.500 A1.500 1.500 0 1 0 4.000 18.500 Z"
  }), n.createElement("path", {
    d: "M20.5.5l-9.782,9.783a7,7,0,1,0,3,3L17,10h1.5V8.5L19,8h1.5V6.5L21,6h1.5V4.5l1-1V.5Z"
  }));
},
    Oe = function Oe() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M2.000 2.500 L22.000 2.500 L22.000 23.500 L2.000 23.500 Z"
  }), n.createElement("path", {
    d: "M6 4.5L6 0.5"
  }), n.createElement("path", {
    d: "M18 4.5L18 0.5"
  }), n.createElement("path", {
    d: "M10 4.5L10 0.5"
  }), n.createElement("path", {
    d: "M14 4.5L14 0.5"
  }));
},
    Fe = function Fe() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M17.5 0.498L17.5 23.498"
  }), n.createElement("path", {
    d: "M10.5 0.498L10.5 23.498"
  }), n.createElement("path", {
    d: "M23.5.5H6.5a6,6,0,0,0,0,12h4"
  }));
},
    Be = function Be() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M2.5 22.995L12 6.005 21.5 22.995 2.5 22.995z"
  }));
},
    ze = function ze(e) {
  var r = e.annotation,
      a = e.childAnnotation,
      i = e.page,
      l = e.viewport,
      c = t.useContext(o),
      s = !1 === r.hasPopup,
      p = !!(r.hasPopup || r.title || r.contents),
      m = r.name ? r.name.toLowerCase() : "";
  return n.createElement(ue, {
    annotation: r,
    hasPopup: s,
    ignoreBorder: !1,
    isRenderable: p,
    page: i,
    viewport: l
  }, function (e) {
    return n.createElement(n.Fragment, null, n.createElement("div", _C({}, e.slot.attrs, {
      className: c.prefixClass + "-annotation " + c.prefixClass + "-annotation-text",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), m && n.createElement("div", {
      className: c.prefixClass + "-annotation-text-icon"
    }, "check" === m && n.createElement(u, null), "comment" === m && n.createElement(Te, null), "help" === m && n.createElement(Ne, null), "insert" === m && n.createElement(Be, null), "key" === m && n.createElement(Re, null), "note" === m && n.createElement(Oe, null), ("newparagraph" === m || "paragraph" === m) && n.createElement(Fe, null)), e.slot.children), a && a.annotationType === ne.Popup && e.popup.opened && n.createElement(ye, {
      annotation: a,
      page: i,
      viewport: l
    }));
  });
},
    He = function He(e) {
  var r = e.annotation,
      a = e.page,
      i = e.viewport,
      l = t.useContext(o),
      c = !1 === r.hasPopup,
      s = !!(r.hasPopup || r.title || r.contents);
  return n.createElement(ue, {
    annotation: r,
    hasPopup: c,
    ignoreBorder: !0,
    isRenderable: s,
    page: a,
    viewport: i
  }, function (e) {
    return n.createElement("div", _C({}, e.slot.attrs, {
      className: l.prefixClass + "-annotation " + l.prefixClass + "-annotation-underline",
      "data-annotation-id": r.id,
      onClick: e.popup.toggleOnClick,
      onMouseEnter: e.popup.openOnHover,
      onMouseLeave: e.popup.closeOnHover
    }), e.slot.children);
  });
},
    De = function De(e) {
  var r = e.doc,
      a = e.page,
      i = e.rotation,
      l = e.scale,
      c = e.onExecuteNamedAction,
      s = e.onJumpToDest,
      u = t.useContext(o);
  return n.createElement("div", {
    className: u.prefixClass + "-annotation-layer"
  }, n.createElement(ee, {
    page: a,
    renderAnnotations: function renderAnnotations(e) {
      var o = a.getViewport({
        rotation: i,
        scale: l
      }).clone({
        dontFlip: !0
      });
      return n.createElement(n.Fragment, null, e.filter(function (e) {
        return !e.parentId;
      }).map(function (i) {
        var l = e.find(function (e) {
          return e.parentId === i.id;
        });

        switch (i.annotationType) {
          case ne.Caret:
            return n.createElement(pe, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Circle:
            return n.createElement(me, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.FileAttachment:
            return n.createElement(ge, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.FreeText:
            return n.createElement(he, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Highlight:
            return n.createElement(ve, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Ink:
            return n.createElement(Ee, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Line:
            return n.createElement(Ce, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Link:
            return n.createElement(be, {
              key: i.id,
              annotation: i,
              doc: r,
              page: a,
              viewport: o,
              onExecuteNamedAction: c,
              onJumpToDest: s
            });

          case ne.Polygon:
            return n.createElement(we, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Polyline:
            return n.createElement(ke, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Popup:
            return n.createElement(ye, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Square:
            return n.createElement(Pe, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Squiggly:
            return n.createElement(Se, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Stamp:
            return n.createElement(Me, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.StrikeOut:
            return n.createElement(Le, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          case ne.Text:
            return n.createElement(ze, {
              key: i.id,
              annotation: i,
              childAnnotation: l,
              page: a,
              viewport: o
            });

          case ne.Underline:
            return n.createElement(He, {
              key: i.id,
              annotation: i,
              page: a,
              viewport: o
            });

          default:
            return n.createElement(t.Fragment, {
              key: i.id
            });
        }
      }));
    }
  }));
},
    Ae = function Ae(e) {
  var r = e.children,
      a = e.threshold,
      o = e.onVisibilityChanged,
      i = t.useRef(null);
  return t.useEffect(function () {
    var e = new IntersectionObserver(function (e) {
      e.forEach(function (e) {
        var t = e.isIntersecting,
            n = e.intersectionRatio;
        o({
          isVisible: t,
          ratio: n
        });
      });
    }, {
      threshold: a || 0
    }),
        t = i.current;
    if (t) return e.observe(t), function () {
      e.unobserve(t);
    };
  }, []), n.createElement("div", {
    ref: i
  }, r);
},
    Ie = function Ie(e) {
  var r = e.callback,
      a = e.children,
      o = e.rotation,
      i = e.scale;
  return t.useLayoutEffect(function () {
    r();
  }, [o, i]), n.createElement(n.Fragment, null, a);
},
    We = function We(e) {
  var r = e.height,
      a = e.page,
      i = e.pageIndex,
      l = e.rotation,
      c = e.scale,
      s = e.width,
      u = e.onCanvasLayerRender,
      p = t.useContext(o),
      m = t.createRef(),
      f = t.useRef(),
      d = window.devicePixelRatio || 1;
  return n.createElement(Ie, {
    callback: function callback() {
      var e = f.current;
      e && e.cancel();
      var t = m.current;
      t.height = r * d, t.width = s * d;
      var n = t.getContext("2d", {
        alpha: !1
      }),
          o = a.getViewport({
        rotation: l,
        scale: c * d
      });
      f.current = a.render({
        canvasContext: n,
        viewport: o
      }), f.current.promise.then(function () {
        u({
          ele: t,
          pageIndex: i,
          rotation: l,
          scale: c
        });
      }, function () {});
    },
    rotation: l,
    scale: c
  }, n.createElement("div", {
    className: p.prefixClass + "-canvas-layer",
    style: {
      height: r + "px",
      width: s + "px"
    }
  }, n.createElement("canvas", {
    ref: m,
    style: {
      transform: "scale(" + 1 / d + ")",
      transformOrigin: "top left"
    }
  })));
},
    Ve = function Ve(e) {
  var a = e.height,
      i = e.page,
      l = e.rotation,
      c = e.scale,
      s = e.width,
      u = t.useContext(o),
      p = t.createRef();
  return n.createElement(Ie, {
    callback: function callback() {
      var e = p.current,
          t = i.getViewport({
        rotation: l,
        scale: c
      });
      i.getOperatorList().then(function (n) {
        !function () {
          var e = p.current;
          e && (e.innerHTML = "");
        }(), new r.SVGGraphics(i.commonObjs, i.objs).getSVG(n, t).then(function (t) {
          t.style.height = a + "px", t.style.width = s + "px", e.appendChild(t);
        });
      });
    },
    rotation: l,
    scale: c
  }, n.createElement("div", {
    className: u.prefixClass + "-svg-layer",
    ref: p
  }));
},
    Je = function Je(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
},
    qe = function qe(e) {
  var t = e.parentNode;

  if (t) {
    var n = document.createRange();
    n.selectNodeContents(e), function (e, t) {
      Je(e);
      var n = t.parentNode;
      n && n.insertBefore(e, t), Je(t);
    }(n.extractContents(), e), t.normalize();
  }
},
    je = function je(e) {
  var a = e.keywordRegexp,
      i = e.match,
      l = e.page,
      c = e.pageIndex,
      s = e.rotation,
      u = e.scale,
      p = e.onJumpToMatch,
      m = e.onTextLayerRender,
      f = t.useContext(o),
      d = t.createRef(),
      g = t.useRef(),
      h = t.useRef(!1),
      v = function v(e) {
    var t = e.textContent;

    if (a.source.trim() && t) {
      var n = t.search(a),
          r = e.firstChild;
      if (-1 !== n && r) (function (e, t, n) {
        var r = new Range();
        r.setStart(e, t), r.setEnd(e, n);
        var a = document.createElement("span");
        return r.surroundContents(a), a;
      })(r, n, n + a.source.length).classList.add(f.prefixClass + "-text-highlight");
    }
  },
      E = function E() {
    var e = d.current;
    if (e) for (var t = e.querySelectorAll("span." + f.prefixClass + "-text-highlight"), n = t.length, r = 0; r < n; r++) {
      qe(t[r]);
    }
  },
      C = function C() {
    var e = d.current;

    if (i.pageIndex === c && e) {
      var t = e.querySelectorAll("span." + f.prefixClass + "-text-highlight");

      if (i.matchIndex < t.length) {
        var n = function (e, t) {
          for (var n = e.offsetTop, r = e.offsetLeft, a = e.parentElement; a && a !== t;) {
            n += a.offsetTop, r += a.offsetLeft, a = a.parentElement;
          }

          return {
            left: r,
            top: n
          };
        }(t[i.matchIndex], e),
            r = n.top,
            a = n.left;

        p(c, r / u, a / u);
      }
    }
  };

  return t.useEffect(function () {
    var e = d.current;
    if (a && h.current && e && (E(), a.source.trim())) for (var t = e.querySelectorAll("span." + f.prefixClass + "-text"), n = t.length, r = 0; r < n; r++) {
      v(t[r]);
    }
  }, [a, h.current]), t.useEffect(function () {
    h.current && C();
  }, [i]), n.createElement(Ie, {
    callback: function callback() {
      var e = g.current;
      e && e.cancel();
      var t = d.current;

      if (t) {
        var n = l.getViewport({
          rotation: s,
          scale: u
        });
        h.current = !1, l.getTextContent().then(function (e) {
          !function () {
            var e = d.current;
            if (e) for (var t = e.querySelectorAll("span." + f.prefixClass + "-text"), n = t.length, r = 0; r < n; r++) {
              var a = t[r];
              e.removeChild(a);
            }
          }(), g.current = r.renderTextLayer({
            container: t,
            textContent: e,
            viewport: n
          }), g.current.promise.then(function () {
            h.current = !0;
            var e = t.childNodes,
                n = e.length;
            a && E();

            for (var r = 0; r < n; r++) {
              var o = e[r];
              o.classList.add(f.prefixClass + "-text"), a && v(o);
            }

            C(), m({
              ele: t
            });
          }, function () {});
        });
      }
    },
    rotation: s,
    scale: u
  }, n.createElement("div", {
    className: f.prefixClass + "-text-layer",
    ref: d
  }));
},
    _e = function _e(e) {
  var r = e.doc,
      a = e.height,
      i = e.keywordRegexp,
      l = e.match,
      c = e.pageIndex,
      s = e.renderPage,
      u = e.rotation,
      p = e.scale,
      m = e.width,
      f = e.onCanvasLayerRender,
      d = e.onExecuteNamedAction,
      h = e.onJumpToDest,
      v = e.onPageVisibilityChanged,
      E = e.onTextLayerRender,
      C = t.useContext(o),
      x = t.useState({
    isCalculated: !1,
    page: null,
    pageHeight: a,
    pageWidth: m,
    viewportRotation: 0
  }),
      b = x[0],
      w = x[1],
      k = b.isCalculated,
      y = b.page,
      P = b.pageHeight,
      S = b.pageWidth,
      M = Array(10).fill(null).map(function (e, t) {
    return t / 10;
  }),
      L = S * p,
      T = P * p,
      N = Math.abs(u) % 180 == 0,
      R = N ? L : T,
      O = N ? T : L,
      F = s || function (e) {
    return n.createElement(n.Fragment, null, e.canvasLayer.children, e.textLayer.children, e.annotationLayer.children);
  },
      B = (u + b.viewportRotation) % 360;

  return n.createElement(Ae, {
    onVisibilityChanged: function onVisibilityChanged(e) {
      var t = e.isVisible ? e.ratio : 0;
      v(c, t), e.isVisible && !k && r.getPage(c + 1).then(function (e) {
        var t = e.getViewport({
          scale: 1
        });
        w({
          isCalculated: !0,
          page: e,
          pageHeight: t.height,
          pageWidth: t.width,
          viewportRotation: t.rotation
        });
      });
    },
    threshold: M
  }, n.createElement("div", {
    className: C.prefixClass + "-page-layer",
    style: {
      height: O + "px",
      width: R + "px"
    }
  }, y ? F({
    annotationLayer: {
      attrs: {},
      children: n.createElement(De, {
        doc: r,
        page: y,
        rotation: B,
        scale: p,
        onExecuteNamedAction: d,
        onJumpToDest: h
      })
    },
    canvasLayer: {
      attrs: {},
      children: n.createElement(We, {
        height: O,
        page: y,
        pageIndex: c,
        rotation: B,
        scale: p,
        width: R,
        onCanvasLayerRender: f
      })
    },
    doc: r,
    height: O,
    pageIndex: c,
    rotation: u,
    scale: p,
    svgLayer: {
      attrs: {},
      children: n.createElement(Ve, {
        height: O,
        page: y,
        rotation: B,
        scale: p,
        width: R
      })
    },
    textLayer: {
      attrs: {},
      children: n.createElement(je, {
        keywordRegexp: i,
        match: l,
        page: y,
        pageIndex: c,
        rotation: B,
        scale: p,
        onJumpToMatch: function onJumpToMatch(e, t, n) {
          h(e, P - t, p);
        },
        onTextLayerRender: E
      })
    },
    width: R
  }) : n.createElement(g, null)));
},
    Ue = n.createContext({}),
    Ze = function Ze() {
  var e = t.useContext(Ue),
      r = t.useContext(o);
  return n.createElement("div", {
    className: r.prefixClass + "-drop-area"
  }, e.main.dragDropFile);
},
    Ge = function Ge(e) {
  var r = e.numLoadedPages,
      a = e.numPages,
      i = e.onCancel,
      l = e.onStartPrinting,
      c = t.useContext(Ue),
      s = t.useContext(o),
      u = Math.floor(100 * r / a);
  return t.useEffect(function () {
    r === a && l();
  }, [r]), n.createElement("div", {
    className: s.prefixClass + "-print-progress"
  }, n.createElement("div", {
    className: s.prefixClass + "-print-progress-inner"
  }, n.createElement("div", {
    className: s.prefixClass + "-print-progress-message"
  }, c.printProgress.preparingDocument), n.createElement("div", {
    className: s.prefixClass + "-print-progress-bar"
  }, n.createElement(f, {
    progress: u
  })), n.createElement(m, {
    onClick: i
  }, c.printProgress.cancel)));
};

!function (e) {
  e.Inactive = "Inactive", e.Preparing = "Preparing", e.Cancelled = "Cancelled", e.Ready = "Ready";
}(se || (se = {}));

var Ke,
    Xe = se,
    Ye = function Ye(e) {
  var r = e.page,
      a = e.pageHeight,
      i = e.pageWidth,
      l = e.rotation,
      c = e.onLoad,
      s = t.useContext(o),
      u = t.useRef(),
      p = t.useState(""),
      m = p[0],
      f = p[1];
  return t.useEffect(function () {
    var e = u.current;
    e && e.cancel();
    var t = document.createElement("canvas");
    t.height = Math.floor(a * (150 / 72)), t.width = Math.floor(i * (150 / 72));
    var n = t.getContext("2d");
    n.save(), n.fillStyle = "rgb(255, 255, 255)", n.fillRect(0, 0, t.width, t.height), n.restore();
    var o = r.getViewport({
      rotation: l,
      scale: 1
    });
    u.current = r.render({
      canvasContext: n,
      intent: "print",
      transform: [150 / 72, 0, 0, 150 / 72, 0, 0],
      viewport: o
    }), u.current.promise.then(function () {
      "toBlob" in t ? t.toBlob(function (e) {
        f(URL.createObjectURL(e));
      }) : f(t.toDataURL());
    }, function () {});
  }, []), m ? n.createElement("div", {
    className: s.prefixClass + "-print-page-thumbnail",
    style: {
      height: Math.floor(96 * a / 72) + "px",
      width: Math.floor(96 * i / 72) + "px"
    }
  }, n.createElement("img", {
    src: m,
    style: {
      height: Math.floor(96 * a / 72) + "px",
      width: Math.floor(96 * i / 72) + "px"
    },
    onLoad: c
  })) : n.createElement(g, null);
},
    Qe = function Qe(e) {
  var r = e.doc,
      a = e.pageHeight,
      o = e.pageIndex,
      i = e.pageWidth,
      l = e.rotation,
      c = e.onLoad,
      s = t.useState({
    height: a,
    page: null,
    viewportRotation: 0,
    width: i
  }),
      u = s[0],
      p = s[1],
      m = u.page,
      f = u.height,
      d = u.width,
      h = Math.abs(l) % 180 == 0;
  t.useEffect(function () {
    r.getPage(o + 1).then(function (e) {
      var t = e.getViewport({
        scale: 1
      });
      p({
        height: t.height,
        page: e,
        viewportRotation: t.rotation,
        width: t.width
      });
    });
  }, []);
  var v = (l + u.viewportRotation) % 360;
  return m ? n.createElement(Ye, {
    page: m,
    pageHeight: h ? f : d,
    pageWidth: h ? d : f,
    rotation: v,
    onLoad: c
  }) : n.createElement(g, null);
},
    $e = function $e(e) {
  var r = e.doc,
      i = e.pageHeight,
      l = e.pageWidth,
      c = e.printStatus,
      s = e.rotation,
      u = e.onCancel,
      p = e.onLoad,
      m = t.useContext(o),
      f = t.useState(0),
      d = f[0],
      g = f[1];
  t.useEffect(function () {
    c === Xe.Ready && (document.body.classList.add(m.prefixClass + "-body-printing"), window.print());

    var e = function e() {
      c === Xe.Ready && (document.body.classList.remove(m.prefixClass + "-body-printing"), u());
    };

    return document.addEventListener("mousemove", e), function () {
      return document.removeEventListener("mousemove", e);
    };
  }, [c]);

  var h = r.numPages,
      v = function v() {
    var e = d + 1;
    g(e), p(e);
  };

  return a.createPortal(n.createElement(n.Fragment, null, n.createElement("div", {
    className: m.prefixClass + "-print-zone"
  }, Array(h).fill(0).map(function (e, t) {
    return n.createElement(Qe, {
      key: t,
      doc: r,
      pageHeight: i,
      pageIndex: t,
      pageWidth: l,
      rotation: s,
      onLoad: v
    });
  })), n.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n                            @supports ((size:A4) and (size:1pt 1pt)) {\n                                @page { size: " + l + "pt " + i + "pt }\n                            }\n                        "
    }
  })), document.body);
},
    et = function et(e) {
  var r = e.doc,
      a = e.pageHeight,
      o = e.pageWidth,
      i = e.printStatus,
      l = e.rotation,
      c = e.onCancel,
      s = e.onStartPrinting,
      u = t.useState(0),
      p = u[0],
      m = u[1],
      f = function f() {
    m(0), c();
  };

  return n.createElement(n.Fragment, null, i === Xe.Preparing && n.createElement(Ge, {
    numLoadedPages: p,
    numPages: r.numPages,
    onCancel: f,
    onStartPrinting: function onStartPrinting() {
      m(0), s();
    }
  }), (i === Xe.Preparing || i === Xe.Ready) && n.createElement($e, {
    doc: r,
    pageHeight: a,
    pageWidth: o,
    printStatus: i,
    rotation: l,
    onCancel: f,
    onLoad: m
  }));
},
    tt = function tt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M10.515,9.514h3c0.552,0,1,0.448,1,1v3c0,0.552-0.448,1-1,1h-3c-0.552,0-1-0.448-1-1v-3\n                C9.515,9.962,9.963,9.514,10.515,9.514z\n                M0.531,23.499l6.984-6.985\n                M16.515,7.514L23.5,0.529\n                M21.515,7.514h-5v-5\n                M7.515,21.514v-5 h-5\n                M0.523,0.521l6.992,6.993\n                M16.515,16.514l6.985,6.985\n                M16.515,21.514v-5h5\n                M2.515,7.514h5v-5"
  }));
},
    nt = function nt(e) {
  var r = e.onClick,
      a = t.useContext(o);
  return n.createElement("div", {
    className: a.prefixClass + "-exit-fullscreen"
  }, n.createElement("div", {
    className: a.prefixClass + "-exit-fullscreen-inner"
  }, n.createElement(l, {
    onClick: r
  }, n.createElement(tt, null))));
},
    rt = function rt(e) {
  var r = e.files,
      a = t.useContext(Ue),
      i = t.useContext(o);
  return 0 === r.length ? n.createElement("div", {
    className: i.prefixClass + "-attachment-list-empty"
  }, a.attachment.noAttachment) : n.createElement("ul", {
    className: i.prefixClass + "-attachment-list"
  }, r.map(function (e) {
    return n.createElement("li", {
      className: i.prefixClass + "-attachment-item",
      key: "attachment-" + e.fileName,
      title: "" + a.attachment.clickToDownload,
      onClick: function onClick() {
        return de(e.fileName, e.data);
      }
    }, e.fileName);
  }));
},
    at = function at(e) {
  var r = e.doc,
      a = t.useState({
    files: [],
    isLoaded: !1
  }),
      o = a[0],
      i = a[1];
  return t.useEffect(function () {
    r.getAttachments().then(function (e) {
      var t = e ? Object.keys(e).map(function (t) {
        return {
          data: e[t].content,
          fileName: e[t].filename
        };
      }) : [];
      i({
        files: t,
        isLoaded: !0
      });
    });
  }, []), o.isLoaded ? n.createElement(rt, {
    files: o.files
  }) : n.createElement(g, null);
},
    ot = function ot(e) {
  var r = e.bookmark,
      a = e.depth,
      i = e.doc,
      l = e.onClick,
      c = e.onJumpToDest,
      s = t.useContext(o),
      u = t.createRef(),
      p = t.createRef(),
      m = t.useRef(!0),
      f = r.items && r.items.length > 0;
  return n.createElement(n.Fragment, null, n.createElement("div", {
    className: s.prefixClass + "-bookmark-item",
    style: {
      paddingLeft: 20 * a + 4 + "px"
    },
    onClick: function onClick() {
      !f && r.dest && l(r.dest);
    }
  }, f && n.createElement("span", {
    ref: u,
    className: s.prefixClass + "-bookmark-toggle",
    onClick: function onClick() {
      m.current = !m.current;
      var e = p.current,
          t = u.current;
      e && t && (e.style.display = m.current ? "block" : "none", t.classList.toggle(s.prefixClass + "-bookmark-toggle-expanded"));
    }
  }, "►"), r.url ? n.createElement("a", {
    className: s.prefixClass + "-bookmark-title",
    href: r.url,
    rel: "noopener noreferrer nofollow",
    target: r.newWindow ? "_blank" : ""
  }, r.title) : n.createElement("div", {
    className: s.prefixClass + "-bookmark-title",
    onClick: function onClick() {
      f && r.dest && l(r.dest);
    }
  }, r.title)), f && n.createElement("div", {
    ref: p
  }, n.createElement(it, {
    bookmarks: r.items,
    depth: a + 1,
    doc: i,
    onJumpToDest: c
  })));
},
    it = function it(e) {
  var r = e.bookmarks,
      a = e.depth,
      i = void 0 === a ? 0 : a,
      l = e.doc,
      c = e.onJumpToDest,
      s = t.useContext(o),
      u = function u(e) {
    xe(l, e).then(function (e) {
      var t = e.pageIndex,
          n = e.bottomOffset,
          r = e.scaleTo;
      c(t + 1, n, r);
    });
  };

  return n.createElement("ul", {
    className: s.prefixClass + "-bookmark-list"
  }, r.map(function (e, t) {
    return n.createElement("li", {
      key: t
    }, n.createElement(ot, {
      bookmark: e,
      depth: i,
      doc: l,
      onClick: u,
      onJumpToDest: c
    }));
  }));
},
    lt = function lt(e) {
  var r = e.doc,
      a = e.onJumpToDest,
      i = t.useContext(Ue),
      l = t.useContext(o),
      c = t.useState({
    isLoaded: !1,
    items: []
  }),
      s = c[0],
      u = c[1];
  return t.useEffect(function () {
    r.getOutline().then(function (e) {
      u({
        isLoaded: !0,
        items: e || []
      });
    });
  }, []), s.isLoaded ? 0 === s.items.length ? n.createElement("div", {
    className: l.prefixClass + "-bookmark-empty"
  }, i.bookmark.noBookmark) : n.createElement(it, {
    bookmarks: s.items,
    depth: 0,
    doc: r,
    onJumpToDest: a
  }) : n.createElement(g, null);
},
    ct = function ct() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M11.5,1.5h11c0.552,0,1,0.448,1,1v20c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h3\n                M11.5,10.5c0,0.55-0.3,0.661-0.659,0.248L8,7.5l-2.844,3.246c-0.363,0.414-0.659,0.3-0.659-0.247v-9c0-0.552,0.448-1,1-1h5\n                c0.552,0,1,0.448,1,1L11.5,10.5z\n                M14.5,6.499h6\n                M14.5,10.499h6\n                M3.5,14.499h17\n                M3.5,18.499h16.497"
  }));
},
    st = function st() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M7.618,15.345l8.666-8.666c0.78-0.812,2.071-0.838,2.883-0.058s0.838,2.071,0.058,2.883\n                c-0.019,0.02-0.038,0.039-0.058,0.058L7.461,21.305c-1.593,1.593-4.175,1.592-5.767,0s-1.592-4.175,0-5.767c0,0,0,0,0,0\n                L13.928,3.305c2.189-2.19,5.739-2.19,7.929-0.001s2.19,5.739,0,7.929l0,0L13.192,19.9"
  }));
},
    ut = function ut() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M10.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n                M23.5,9.5c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V9.5z\n                M10.5,22.5 c0,0.552-0.448,1-1,1h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z\n                M23.5,22.5c0,0.552-0.448,1-1,1 h-8c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h8c0.552,0,1,0.448,1,1V22.5z"
  }));
},
    pt = function pt(e) {
  var r = e.page,
      a = e.pageHeight,
      o = e.pageWidth,
      i = e.rotation,
      l = e.thumbnailHeight,
      c = e.thumbnailWidth,
      s = t.useRef(),
      u = t.useState(""),
      p = u[0],
      m = u[1];
  return t.useEffect(function () {
    var e = s.current;
    e && e.cancel();
    var t = document.createElement("canvas"),
        n = t.getContext("2d", {
      alpha: !1
    }),
        l = c,
        u = l / (o / a),
        p = l / o;
    t.height = u, t.width = l, t.style.height = u + "px", t.style.width = l + "px";
    var f = r.getViewport({
      rotation: i,
      scale: p
    });
    s.current = r.render({
      canvasContext: n,
      viewport: f
    }), s.current.promise.then(function () {
      return m(t.toDataURL());
    }, function () {});
  }, [i]), p ? n.createElement("img", {
    src: p,
    height: l + "px",
    width: c + "px"
  }) : n.createElement(g, null);
},
    mt = function mt(e) {
  var r = e.doc,
      a = e.pageHeight,
      i = e.pageIndex,
      l = e.pageWidth,
      c = e.rotation,
      s = t.useContext(o),
      u = t.useState({
    height: a,
    isCalculated: !1,
    page: null,
    viewportRotation: 0,
    width: l
  }),
      p = u[0],
      m = u[1],
      f = p.isCalculated,
      d = p.page,
      h = p.height,
      v = p.width,
      E = v / h,
      C = Math.abs(c) % 180 == 0,
      x = C ? 100 : 100 / E,
      b = C ? 100 / E : 100,
      w = (c + p.viewportRotation) % 360;
  return n.createElement(Ae, {
    onVisibilityChanged: function onVisibilityChanged(e) {
      e.isVisible && !f && r.getPage(i + 1).then(function (e) {
        var t = e.getViewport({
          scale: 1
        });
        m({
          height: t.height,
          isCalculated: !0,
          page: e,
          viewportRotation: t.rotation,
          width: t.width
        });
      });
    }
  }, n.createElement("div", {
    className: s.prefixClass + "-thumbnail-container",
    style: {
      height: b + "px",
      width: x + "px"
    }
  }, d ? n.createElement(pt, {
    page: d,
    pageHeight: C ? h : v,
    pageWidth: C ? v : h,
    rotation: w,
    thumbnailHeight: b,
    thumbnailWidth: x
  }) : n.createElement(g, null)));
},
    ft = function ft(e) {
  var r = e.currentPage,
      a = e.doc,
      l = e.pageHeight,
      c = e.pageWidth,
      s = e.rotation,
      u = e.onJumpToPage,
      p = t.useContext(o),
      m = a.numPages;
  return n.createElement(n.Fragment, null, Array(m).fill(0).map(function (e, t) {
    var o;
    return n.createElement("div", {
      key: "thumbnail-" + t
    }, n.createElement("div", {
      className: i((o = {}, o[p.prefixClass + "-thumbnail"] = !0, o[p.prefixClass + "-thumbnail-selected"] = r === t, o)),
      onClick: function onClick() {
        return u(t);
      }
    }, n.createElement(mt, {
      doc: a,
      pageHeight: l,
      pageIndex: t,
      pageWidth: c,
      rotation: s
    })));
  }));
};

!function (e) {
  e.Attachment = "Attachment", e.Bookmark = "Bookmark", e.Thumbnail = "Thumbnail";
}(Ke || (Ke = {}));

var dt = {
  left: 0,
  top: 8
},
    gt = function gt(e) {
  var r,
      a = e.currentPage,
      c = e.doc,
      s = e.height,
      u = e.rotation,
      p = e.width,
      m = e.onJumpToDest,
      f = e.onJumpToPage,
      d = t.useContext(Ue),
      g = t.useContext(o),
      h = t.useState(Ke.Thumbnail),
      v = h[0],
      E = h[1];
  return n.createElement("div", {
    className: g.prefixClass + "-sidebar"
  }, n.createElement("div", {
    className: g.prefixClass + "-sidebar-tabs"
  }, n.createElement("div", {
    className: g.prefixClass + "-sidebar-tab"
  }, n.createElement(A, {
    position: R.BottomCenter,
    target: n.createElement(l, {
      onClick: function onClick() {
        return E(Ke.Thumbnail);
      },
      isSelected: v === Ke.Thumbnail
    }, n.createElement(ut, null)),
    content: function content() {
      return d.sidebar.thumbnail;
    },
    offset: dt
  })), n.createElement("div", {
    className: g.prefixClass + "-sidebar-tab"
  }, n.createElement(A, {
    position: R.BottomCenter,
    target: n.createElement(l, {
      onClick: function onClick() {
        return E(Ke.Bookmark);
      },
      isSelected: v === Ke.Bookmark
    }, n.createElement(ct, null)),
    content: function content() {
      return d.sidebar.bookmark;
    },
    offset: dt
  })), n.createElement("div", {
    className: g.prefixClass + "-sidebar-tab"
  }, n.createElement(A, {
    position: R.BottomCenter,
    target: n.createElement(l, {
      onClick: function onClick() {
        return E(Ke.Attachment);
      },
      isSelected: v === Ke.Attachment
    }, n.createElement(st, null)),
    content: function content() {
      return d.sidebar.attachment;
    },
    offset: dt
  }))), n.createElement("div", {
    className: i((r = {}, r[g.prefixClass + "-sidebar-content"] = !0, r[g.prefixClass + "-sidebar-thumbnails"] = v === Ke.Thumbnail, r))
  }, v === Ke.Thumbnail && n.createElement(ft, {
    currentPage: a,
    doc: c,
    pageHeight: s,
    pageWidth: p,
    rotation: u,
    onJumpToPage: f
  }), v === Ke.Bookmark && n.createElement(lt, {
    doc: c,
    onJumpToDest: m
  }), v === Ke.Attachment && n.createElement(at, {
    doc: c
  })));
},
    ht = function ht() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M2.32,2.966h19.452c0.552,0.001,1,0.449,0.999,1.001c0,0.182-0.05,0.36-0.144,0.516L12.9,20.552\n                c-0.286,0.472-0.901,0.624-1.373,0.338c-0.138-0.084-0.254-0.2-0.338-0.338L1.465,4.483C1.179,4.01,1.331,3.396,1.804,3.11\n                C1.96,3.016,2.138,2.966,2.32,2.966z"
  }));
},
    vt = function vt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M17.5,11.5c3.314,0,6,2.686,6,6s-2.686,6-6,6s-6-2.686-6-6S14.186,11.5,17.5,11.5z\n                M17.5,14.5v6\n                M17.5,20.5\n                l-2.25-2.25\n                M17.5,20.5l2.25-2.25\n                M10.5,23.5h-9c-0.552,0-1-0.448-1-1v-21c0-0.552,0.448-1,1-1h13.293\n                c0.265,0,0.52,0.105,0.707,0.293L19.207,4.5C19.395,4.687,19.5,4.942,19.5,5.207V8.5"
  }));
},
    Et = function Et() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M15.5,8.499l8-8\n                M0.5,23.499l8-8\n                M5.5,23.499h-5v-5\n                M23.5,5.499v-5h-5\n                M15.5,15.499l8,8\n                M0.5,0.499l8,8\n                M0.5,5.499v-5h5\n                M18.5,23.499h5v-5"
  }));
},
    Ct = function Ct() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M11.5,5.5v-2C11.5,2.672,12.172,2,13,2s1.5,0.672,1.5,1.5v2 M14.5,11.5v-6C14.5,4.672,15.172,4,16,4\n                c0.828,0,1.5,0.672,1.5,1.5v3 M17.5,13V8.5C17.5,7.672,18.172,7,19,7s1.5,0.672,1.5,1.5v10c0,2.761-2.239,5-5,5h-3.335\n                c-1.712-0.001-3.305-0.876-4.223-2.321C6.22,18.467,4.083,14,4.083,14c-0.378-0.545-0.242-1.292,0.303-1.67\n                c0.446-0.309,1.044-0.281,1.458,0.07L8.5,15.5v-10C8.5,4.672,9.172,4,10,4s1.5,0.672,1.5,1.5v6"
  }));
},
    xt = function xt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M6.5,21.5c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z\n                M14.5,21.5c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z\n                M22.5,21.5 c0,0.552-0.448,1-1,1h-4c-0.552,0-1-0.448-1-1v-20c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1V21.5z"
  }));
},
    bt = function bt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M12,1.001c6.075,0,11,4.925,11,11s-4.925,11-11,11s-11-4.925-11-11S5.925,1.001,12,1.001z\n                M14.5,17.005H13\n                c-0.552,0-1-0.448-1-1v-6.5c0-0.276-0.224-0.5-0.5-0.5H10\n                M11.745,6.504L11.745,6.504\n                M11.745,6.5c-0.138,0-0.25,0.112-0.25,0.25\n                S11.607,7,11.745,7s0.25-0.112,0.25-0.25S11.883,6.5,11.745,6.5"
  }));
},
    wt = function wt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M1.5,0.497h20c0.552,0,1,0.448,1,1v20c0,0.552-0.448,1-1,1h-20c-0.552,0-1-0.448-1-1v-20\n                C0.5,0.945,0.948,0.497,1.5,0.497z\n                M7.5,0.497v22"
  }));
},
    kt = function kt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M0.541,5.627L11.666,18.2c0.183,0.207,0.499,0.226,0.706,0.043c0.015-0.014,0.03-0.028,0.043-0.043\n                L23.541,5.627"
  }));
},
    yt = function yt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M23.535,18.373L12.409,5.8c-0.183-0.207-0.499-0.226-0.706-0.043C11.688,5.77,11.674,5.785,11.66,5.8\n                L0.535,18.373"
  }));
},
    Pt = function Pt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M7.5,19.499h9 M7.5,16.499h9 M5.5,16.5h-3c-1.103-0.003-1.997-0.897-2-2v-6c0.003-1.103,0.897-1.997,2-2h19\n                c1.103,0.003,1.997,0.897,2,2v6c-0.003,1.103-0.897,1.997-2,2h-3\n                M5.5,4.5v-4h9.586c0.265,0,0.52,0.105,0.707,0.293l2.414,2.414\n                C18.395,3.394,18.5,3.649,18.5,3.914V4.5\n                M18.5,22.5c0,0.552-0.448,1-1,1h-11c-0.552,0-1-0.448-1-1v-9h13V22.5z\n                M3.5,8.499\n                c0.552,0,1,0.448,1,1s-0.448,1-1,1s-1-0.448-1-1S2.948,8.499,3.5,8.499z\n                M14.5,0.499v4h4"
  }));
},
    St = function St() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M3.434,10.537c0.141-0.438,0.316-0.864,0.523-1.274\n                M3.069,14.425C3.023,14.053,3,13.679,3,13.305 c0-0.291,0.014-0.579,0.041-0.863\n                M4.389,18.111c-0.341-0.539-0.623-1.112-0.843-1.711\n                M7.163,20.9 c-0.543-0.345-1.048-0.747-1.506-1.2\n                M10.98,22.248c-0.65-0.074-1.29-0.218-1.909-0.431\n                M10,4.25h2 c4.987,0.015,9.017,4.069,9.003,9.055c-0.013,4.581-3.456,8.426-8.008,8.945\n                M13.5,1.75L10,4.25l3.5,2.5"
  }));
},
    Mt = function Mt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M20.566,10.537c-0.141-0.438-0.316-0.864-0.523-1.274\n                M20.931,14.425C20.977,14.053,21,13.679,21,13.305 c0-0.291-0.014-0.579-0.041-0.863\n                M19.611,18.111c0.341-0.539,0.624-1.114,0.843-1.713\n                M16.837,20.9 c0.543-0.345,1.048-0.747,1.506-1.2\n                M13.02,22.248c0.65-0.074,1.29-0.218,1.909-0.431\n                M14,4.25h-2 c-4.987,0.015-9.017,4.069-9.003,9.055c0.013,4.581,3.456,8.426,8.008,8.945\n                M10.5,1.75l3.5,2.5l-3.5,2.5"
  }));
},
    Lt = function Lt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M13.675,11.671l2.941-2.941c0.195-0.196,0.195-0.512-0.001-0.707C16.563,7.971,16.5,7.931,16.43,7.906\n                L4.168,3.527C3.908,3.434,3.622,3.57,3.529,3.83c-0.039,0.109-0.039,0.228,0,0.336l4.379,12.262\n                c0.093,0.26,0.379,0.396,0.639,0.303c0.07-0.025,0.133-0.065,0.185-0.117l2.943-2.943l6.146,6.146c0.195,0.195,0.512,0.195,0.707,0\n                l1.293-1.293c0.195-0.195,0.195-0.512,0-0.707L13.675,11.671z"
  }));
},
    Tt = function Tt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M21.783,21.034H2.332c-0.552,0-1-0.448-1-1c0-0.182,0.05-0.361,0.144-0.517L11.2,3.448\n                c0.286-0.472,0.901-0.624,1.373-0.338c0.138,0.084,0.254,0.2,0.338,0.338l9.726,16.069c0.286,0.473,0.134,1.087-0.339,1.373\n                C22.143,20.984,21.965,21.034,21.783,21.034z"
  }));
},
    Nt = function Nt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M23.5,5.5c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V5.5z\n                M23.5,13.5c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V13.5z\n                M23.5,21.5 c0,0.552-0.448,1-1,1h-21c-0.552,0-1-0.448-1-1v-3c0-0.552,0.448-1,1-1h21c0.552,0,1,0.448,1,1V21.5z"
  }));
},
    Rt = function Rt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n                M23.5,23.499\n                l-5.929-5.929\n                M5.5,10.499h10\n                M10.5,5.499v10"
  }));
},
    Ot = function Ot() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M10.5,0.499c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.499,10.5,0.499z\n                M23.5,23.499\n                l-5.929-5.929\n                M5.5,10.499h10"
  }));
},
    Ft = function Ft() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M4.5,8.5H14\n                M4.5,11.5h6\n                M4.5,5.5h7\n                M4.5,14.5h4\n                M4.5,17.5h4\n                M10.5,23.5h-9c-0.552,0-1-0.448-1-1v-21\n                c0-0.552,0.448-1,1-1h13.293c0.265,0,0.52,0.105,0.707,0.293L19.207,4.5C19.395,4.687,19.5,4.942,19.5,5.207V8.5\n                M17.5,11.5\n                c3.314,0,6,2.686,6,6s-2.686,6-6,6s-6-2.686-6-6S14.186,11.5,17.5,11.5z\n                M17.5,20.5v-6\n                M17.5,14.5l-2.25,2.25\n                M17.5,14.5l2.25,2.25"
  }));
},
    Bt = {
  left: 0,
  top: 8
},
    zt = function zt(e) {
  var r = e.onOpenFiles,
      a = t.useContext(Ue),
      i = t.useContext(o);
  return n.createElement(A, {
    position: R.BottomCenter,
    target: n.createElement("div", {
      className: i.prefixClass + "-open-file"
    }, n.createElement("input", {
      className: i.prefixClass + "-open-file-input",
      multiple: !1,
      type: "file",
      title: "",
      onChange: function onChange(e) {
        var t = e.target.files;
        t && r(t);
      }
    }), n.createElement(Ft, null)),
    content: function content() {
      return a.toolbar.openFile;
    },
    offset: Bt
  });
},
    Ht = function Ht(e) {
  var r = e.doc,
      a = e.render,
      i = t.useContext(o),
      l = t.useState(),
      c = l[0],
      s = l[1];
  return t.useEffect(function () {
    r.getMetadata().then(function (e) {
      return Promise.resolve(e);
    }).then(function (e) {
      return r.getDownloadInfo().then(function (t) {
        return Promise.resolve({
          fileName: e.contentDispositionFilename || "",
          info: e.info,
          length: t.length
        });
      });
    }).then(function (e) {
      s(e);
    });
  }, []), c ? a(c) : n.createElement("div", {
    className: i.prefixClass + "-properties-loader"
  }, n.createElement(g, null));
},
    Dt = function Dt(e) {
  var r = e.label,
      a = e.value,
      i = t.useContext(o);
  return n.createElement("dl", {
    className: i.prefixClass + "-property-item"
  }, n.createElement("dt", {
    className: i.prefixClass + "-property-item-label"
  }, r, ":"), n.createElement("dd", {
    className: i.prefixClass + "-property-item-value"
  }, a || "-"));
},
    At = function At(e) {
  var r = e.doc,
      a = e.fileName,
      i = e.onToggle,
      l = t.useContext(Ue),
      c = t.useContext(o),
      s = function s(e) {
    var t = le(e);
    return t ? t.toLocaleDateString() + ", " + t.toLocaleTimeString() : "";
  };

  return n.createElement("div", {
    className: c.prefixClass + "-properties-modal"
  }, n.createElement(Ht, {
    doc: r,
    render: function render(e) {
      return n.createElement(n.Fragment, null, n.createElement("div", {
        className: c.prefixClass + "-properties-modal-group"
      }, n.createElement(Dt, {
        label: "" + l.property.fileName,
        value: e.fileName || fe(a)
      }), n.createElement(Dt, {
        label: "" + l.property.fileSize,
        value: (t = e.length, o = Math.floor(Math.log(t) / Math.log(1024)), (t / Math.pow(1024, o)).toFixed(2) + " " + ["B", "kB", "MB", "GB", "TB"][o])
      })), n.createElement(d, null), n.createElement("div", {
        className: c.prefixClass + "-properties-modal-group"
      }, n.createElement(Dt, {
        label: "" + l.property.title,
        value: e.info.Title
      }), n.createElement(Dt, {
        label: "" + l.property.author,
        value: e.info.Author
      }), n.createElement(Dt, {
        label: "" + l.property.subject,
        value: e.info.Subject
      }), n.createElement(Dt, {
        label: "" + l.property.keywords,
        value: e.info.Keywords
      }), n.createElement(Dt, {
        label: "" + l.property.creator,
        value: e.info.Creator
      }), n.createElement(Dt, {
        label: "" + l.property.creationDate,
        value: s(e.info.CreationDate)
      }), n.createElement(Dt, {
        label: "" + l.property.modificationDate,
        value: s(e.info.ModDate)
      })), n.createElement(d, null), n.createElement("div", {
        className: c.prefixClass + "-properties-modal-group"
      }, n.createElement(Dt, {
        label: "" + l.property.pdfProducer,
        value: e.info.Producer
      }), n.createElement(Dt, {
        label: "" + l.property.pdfVersion,
        value: e.info.PDFFormatVersion
      }), n.createElement(Dt, {
        label: "" + l.property.pageCount,
        value: "" + r.numPages
      })));
      var t, o;
    }
  }), n.createElement("div", {
    className: c.prefixClass + "-properties-modal-footer"
  }, n.createElement(m, {
    onClick: i
  }, l.property.close)));
},
    It = function It() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M10.5,0.5c5.523,0,10,4.477,10,10s-4.477,10-10,10s-10-4.477-10-10S4.977,0.5,10.5,0.5z\n                M23.5,23.5\n                l-5.929-5.929"
  }));
},
    Wt = new RegExp(" "),
    Vt = {
  left: 0,
  top: 8
},
    Jt = function Jt(e) {
  var r = e.doc,
      a = e.onJumpToMatch,
      i = e.onSearchFor,
      c = t.useContext(o),
      s = r.numPages,
      u = Array(s).fill(0).map(function (e, t) {
    return t;
  }),
      p = t.useContext(Ue),
      f = t.useState(""),
      d = f[0],
      g = f[1],
      h = t.useState([]),
      v = h[0],
      E = h[1],
      C = t.useState(0),
      x = C[0],
      b = C[1],
      w = t.useState(!1),
      k = w[0],
      y = w[1],
      P = t.useState(!1),
      S = P[0],
      M = P[1],
      L = t.useRef([]),
      T = function T(e) {
    g(e.target.value);
  },
      N = function N(e, t, n) {
    var o,
        l = function (e, t, n) {
      return new RegExp(n ? " " + e + " " : e, t ? "g" : "gi");
    }(e, t, n);

    i(l), b(0), E([]), (0 === L.current.length ? (o = u.map(function (e) {
      return r.getPage(e + 1).then(function (e) {
        return e.getTextContent();
      }).then(function (t) {
        var n = t.items.map(function (e) {
          return e.str || "";
        }).join("");
        return Promise.resolve({
          pageContent: n,
          pageIndex: e
        });
      });
    }), Promise.all(o).then(function (e) {
      return e.sort(function (e, t) {
        return e.pageIndex - t.pageIndex;
      }), Promise.resolve(e.map(function (e) {
        return e.pageContent;
      }));
    })).then(function (e) {
      return L.current = e, Promise.resolve(e);
    }) : Promise.resolve(L.current)).then(function (e) {
      var t = [];
      e.forEach(function (e, n) {
        for (var r = (e.match(l) || []).length, a = 0; a < r; a++) {
          t.push({
            matchIndex: a,
            pageIndex: n
          });
        }
      }), E(t), t.length > 0 && (b(1), a(t[0]));
    });
  },
      O = function O(e) {
    13 === e.keyCode && d && N(d, k, S);
  },
      F = function F() {
    var e = x - 1,
        t = e > 0 ? e : v.length;
    b(t), a(v[t - 1]);
  },
      B = function B() {
    var e = x + 1,
        t = e <= v.length ? e : 1;
    b(t), a(v[t - 1]);
  },
      z = function z(e) {
    var t = e.target.checked;
    y(t), d && N(d, t, S);
  },
      D = function D(e) {
    var t = e.target.checked;
    M(t), d && N(d, k, t);
  },
      I = function I() {
    return p.toolbar.search;
  },
      W = function W() {
    return p.search.previousMatch;
  },
      V = function V() {
    return p.search.nextMatch;
  };

  return n.createElement(H, {
    position: R.BottomLeft,
    target: function target(e, t) {
      return n.createElement(A, {
        position: R.BottomCenter,
        target: n.createElement(l, {
          onClick: e,
          isSelected: t
        }, n.createElement(It, null)),
        content: I,
        offset: Vt
      });
    },
    content: function content(e) {
      return n.createElement("div", {
        className: c.prefixClass + "-search-popover"
      }, n.createElement("div", {
        className: c.prefixClass + "-search-popover-input-counter"
      }, n.createElement("input", {
        className: c.prefixClass + "-search-popover-input",
        placeholder: "" + p.search.enterToSearch,
        type: "text",
        value: d,
        onChange: T,
        onKeyDown: O
      }), n.createElement("div", {
        className: c.prefixClass + "-search-popover-counter"
      }, x, "/", v.length)), n.createElement("label", {
        className: c.prefixClass + "-search-popover-label"
      }, n.createElement("input", {
        className: c.prefixClass + "-search-popover-label-checkbox",
        checked: k,
        type: "checkbox",
        onChange: z
      }), " ", p.search.matchCase), n.createElement("label", {
        className: c.prefixClass + "-search-popover-label"
      }, n.createElement("input", {
        className: c.prefixClass + "-search-popover-label-checkbox",
        checked: S,
        type: "checkbox",
        onChange: D
      }), " ", p.search.wholeWords), n.createElement("div", {
        className: c.prefixClass + "-search-popover-footer"
      }, n.createElement("div", {
        className: c.prefixClass + "-search-popover-footer-item"
      }, n.createElement(A, {
        position: R.BottomCenter,
        target: n.createElement(l, {
          onClick: F
        }, n.createElement(yt, null)),
        content: W,
        offset: Vt
      })), n.createElement("div", {
        className: c.prefixClass + "-search-popover-footer-item"
      }, n.createElement(A, {
        position: R.BottomCenter,
        target: n.createElement(l, {
          onClick: B
        }, n.createElement(kt, null)),
        content: V,
        offset: Vt
      })), n.createElement("div", {
        className: c.prefixClass + "-search-popover-footer-button"
      }, n.createElement(m, {
        onClick: function onClick() {
          e(), i(Wt), g(""), b(0), E([]), y(!1), M(!1);
        }
      }, p.search.close))));
    },
    offset: Vt,
    closeOnClickOutside: !1,
    closeOnEscape: !0
  });
},
    qt = [.1, .2, .3, .4, .5, .6, .7, .8, .9, 1, 1.1, 1.3, 1.5, 1.7, 1.9, 2.1, 2.4, 2.7, 3, 3.3, 3.7, 4.1, 4.6, 5.1, 5.7, 6.3, 7, 7.7, 8.5, 9.4, 10],
    jt = function jt(e) {
  var t = qt.findIndex(function (t) {
    return t >= e;
  });
  return -1 === t || 0 === t ? e : qt[t - 1];
},
    _t = function _t(e) {
  var r = e.children,
      a = t.useContext(o);
  return n.createElement("ul", {
    className: a.prefixClass + "-menu"
  }, r);
},
    Ut = [.5, .75, 1, 1.25, 1.5, 2, 3, 4],
    Zt = {
  left: 0,
  top: 8
},
    Gt = function Gt(e) {
  var r = e.scale,
      a = e.onZoom,
      i = t.useContext(Ue),
      l = t.useContext(o);
  return n.createElement(H, {
    position: R.BottomCenter,
    target: function target(e) {
      return n.createElement("span", {
        className: l.prefixClass + "-zoom-popover-target",
        onClick: function onClick() {
          e();
        }
      }, n.createElement("span", {
        className: l.prefixClass + "-zoom-popover-target-scale"
      }, Math.round(100 * r), "%"), n.createElement("span", {
        className: l.prefixClass + "-zoom-popover-target-arrow"
      }));
    },
    content: function content(e) {
      return n.createElement(_t, null, Object.keys(j).map(function (t) {
        var r = t;
        return n.createElement(p, {
          key: r,
          onClick: function onClick() {
            e(), a(r);
          }
        }, function (e) {
          switch (e) {
            case j.ActualSize:
              return i.zoom.actualSize;

            case j.PageFit:
              return i.zoom.pageFit;

            case j.PageWidth:
              return i.zoom.pageWidth;
          }
        }(r));
      }), n.createElement(c, null), Ut.map(function (t) {
        return n.createElement(p, {
          key: t,
          onClick: function onClick() {
            e(), a(t);
          }
        }, Math.round(100 * t) + "%");
      }));
    },
    offset: Zt,
    closeOnClickOutside: !0,
    closeOnEscape: !0
  });
},
    Kt = function Kt() {
  return n.createElement(s, {
    size: 16
  }, n.createElement("path", {
    d: "M12,0.5c1.381,0,2.5,1.119,2.5,2.5S13.381,5.5,12,5.5S9.5,4.381,9.5,3S10.619,0.5,12,0.5z\n                M12,9.5\n                c1.381,0,2.5,1.119,2.5,2.5s-1.119,2.5-2.5,2.5S9.5,13.381,9.5,12S10.619,9.5,12,9.5z\n                M12,18.5c1.381,0,2.5,1.119,2.5,2.5\n                s-1.119,2.5-2.5,2.5S9.5,22.381,9.5,21S10.619,18.5,12,18.5z"
  }));
},
    Xt = {
  left: 0,
  top: 8
},
    Yt = function Yt(e) {
  var r = e.doc,
      a = e.fileName,
      o = e.scrollMode,
      i = e.selectionMode,
      s = e.onChangeScrollMode,
      u = e.onChangeSelectionMode,
      m = e.onJumpToFirstPage,
      f = e.onJumpToLastPage,
      d = e.onRotate,
      g = t.useContext(Ue),
      h = function h() {
    return g.toolbar.moreActions;
  },
      v = function v(e) {
    return n.createElement(p, {
      icon: n.createElement(bt, null),
      onClick: e
    }, g.toolbar.documentProperties);
  },
      E = function E(e) {
    return n.createElement(At, {
      doc: r,
      fileName: a,
      onToggle: e
    });
  };

  return n.createElement(H, {
    position: R.BottomRight,
    target: function target(e, t) {
      return n.createElement(A, {
        position: R.BottomRight,
        target: n.createElement(l, {
          onClick: e,
          isSelected: t
        }, n.createElement(Kt, null)),
        content: h,
        offset: Xt
      });
    },
    content: function content(e) {
      var t = function t(_t2) {
        e(), s(_t2);
      };

      return n.createElement(_t, null, n.createElement(p, {
        icon: n.createElement(Tt, null),
        onClick: function onClick() {
          e(), m();
        }
      }, g.toolbar.goToFirstPage), n.createElement(p, {
        icon: n.createElement(ht, null),
        onClick: function onClick() {
          e(), f();
        }
      }, g.toolbar.goToLastPage), n.createElement(c, null), n.createElement(p, {
        icon: n.createElement(Mt, null),
        onClick: function onClick() {
          e(), d(90);
        }
      }, g.toolbar.rotateForward), n.createElement(p, {
        icon: n.createElement(St, null),
        onClick: function onClick() {
          e(), d(-90);
        }
      }, g.toolbar.rotateBackward), n.createElement(c, null), n.createElement(p, {
        checked: i === J.Text,
        icon: n.createElement(Lt, null),
        onClick: function onClick() {
          e(), u(J.Text);
        }
      }, g.toolbar.textSelectionTool), n.createElement(p, {
        checked: i === J.Hand,
        icon: n.createElement(Ct, null),
        onClick: function onClick() {
          e(), u(J.Hand);
        }
      }, g.toolbar.handTool), n.createElement(c, null), n.createElement(p, {
        checked: o === W.Vertical,
        icon: n.createElement(Nt, null),
        onClick: function onClick() {
          return t(W.Vertical);
        }
      }, g.toolbar.verticalScrolling), n.createElement(p, {
        checked: o === W.Horizontal,
        icon: n.createElement(xt, null),
        onClick: function onClick() {
          return t(W.Horizontal);
        }
      }, g.toolbar.horizontalScrolling), n.createElement(p, {
        checked: o === W.Wrapped,
        icon: n.createElement(ut, null),
        onClick: function onClick() {
          return t(W.Wrapped);
        }
      }, g.toolbar.wrappedScrolling), n.createElement(c, null), n.createElement(T, {
        target: v,
        content: E,
        closeOnClickOutside: !0,
        closeOnEscape: !0
      }));
    },
    offset: Xt,
    closeOnClickOutside: !0,
    closeOnEscape: !0
  });
},
    Qt = {
  left: 0,
  top: 8
},
    $t = function $t(e) {
  var r = e.currentPage,
      a = e.doc,
      i = e.fileName,
      c = e.scale,
      s = e.scrollMode,
      u = e.selectionMode,
      p = e.onChangeScrollMode,
      m = e.onChangeSelectionMode,
      f = e.onDownload,
      d = e.onFullScreen,
      g = e.onJumpTo,
      h = e.onJumpToMatch,
      v = e.onOpenFiles,
      E = e.onPrint,
      C = e.onRotate,
      x = e.onSearchFor,
      b = e.onToggleSidebar,
      w = e.onZoom,
      k = e.renderToolbar,
      y = t.useContext(Ue),
      P = t.useContext(o),
      S = t.useState(!1),
      M = S[0],
      L = S[1],
      N = t.useState(r),
      O = N[0],
      F = N[1],
      B = t.useState(!1),
      z = B[0],
      H = B[1],
      D = a.numPages,
      I = function I() {
    var e = r + 1;
    e < D && (F(e), g(e));
  },
      V = function V() {
    var e = r - 1;
    e >= 0 && (F(e), g(e));
  },
      q = function q() {
    return g(0);
  },
      j = function j() {
    return g(D - 1);
  },
      _ = function _() {
    return y.toolbar.documentProperties;
  };

  return k({
    currentPage: r,
    currentPageInput: n.createElement("input", {
      className: P.prefixClass + "-toolbar-current-page-input",
      type: "text",
      value: M ? O + 1 : r + 1,
      onChange: function onChange(e) {
        var t = parseInt(e.target.value, 10);
        t > 0 && t <= D && F(t - 1);
      },
      onFocus: function onFocus() {
        L(!0), F(r);
      },
      onBlur: function onBlur() {
        L(!1);
      },
      onKeyDown: function onKeyDown(e) {
        switch (e.keyCode) {
          case 38:
            V();
            break;

          case 40:
            I();
            break;

          case 13:
            g(O);
        }
      }
    }),
    documentPropertiesButton: n.createElement(T, {
      target: function target(e) {
        return n.createElement(A, {
          position: R.BottomCenter,
          target: n.createElement(l, {
            onClick: e
          }, n.createElement(bt, null)),
          content: _,
          offset: Qt
        });
      },
      content: function content(e) {
        return n.createElement(At, {
          doc: a,
          fileName: i,
          onToggle: e
        });
      },
      closeOnClickOutside: !0,
      closeOnEscape: !0
    }),
    downloadButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: f
      }, n.createElement(vt, null)),
      content: function content() {
        return y.toolbar.download;
      },
      offset: Qt
    }),
    fullScreenButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: d
      }, n.createElement(Et, null)),
      content: function content() {
        return y.toolbar.fullScreen;
      },
      offset: Qt
    }),
    goToFirstPageButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: q
      }, n.createElement(Tt, null)),
      content: function content() {
        return y.toolbar.goToFirstPage;
      },
      offset: Qt
    }),
    goToLastPageButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: j
      }, n.createElement(ht, null)),
      content: function content() {
        return y.toolbar.goToLastPage;
      },
      offset: Qt
    }),
    handToolButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return m(J.Hand);
        },
        isSelected: u === J.Hand
      }, n.createElement(Ct, null)),
      content: function content() {
        return y.toolbar.handTool;
      },
      offset: Qt
    }),
    horizontalScrollingButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return p(W.Horizontal);
        },
        isSelected: s === W.Horizontal
      }, n.createElement(xt, null)),
      content: function content() {
        return y.toolbar.horizontalScrolling;
      },
      offset: Qt
    }),
    moreActionsPopover: n.createElement(Yt, {
      doc: a,
      fileName: i,
      scrollMode: s,
      selectionMode: u,
      onChangeScrollMode: p,
      onChangeSelectionMode: m,
      onJumpToFirstPage: q,
      onJumpToLastPage: j,
      onRotate: C
    }),
    nextPageButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: I
      }, n.createElement(kt, null)),
      content: function content() {
        return y.toolbar.nextPage;
      },
      offset: Qt
    }),
    numPages: D,
    openFileButton: n.createElement(zt, {
      onOpenFiles: v
    }),
    previousPageButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: V
      }, n.createElement(yt, null)),
      content: function content() {
        return y.toolbar.previousPage;
      },
      offset: Qt
    }),
    printButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: E
      }, n.createElement(Pt, null)),
      content: function content() {
        return y.toolbar.print;
      },
      offset: Qt
    }),
    rotateClockwiseButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return C(90);
        }
      }, n.createElement(Mt, null)),
      content: function content() {
        return y.toolbar.rotateForward;
      },
      offset: Qt
    }),
    rotateCounterclockwiseButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return C(-90);
        }
      }, n.createElement(St, null)),
      content: function content() {
        return y.toolbar.rotateBackward;
      },
      offset: Qt
    }),
    searchPopover: n.createElement(Jt, {
      doc: a,
      onJumpToMatch: h,
      onSearchFor: x
    }),
    textSelectionButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return m(J.Text);
        },
        isSelected: u === J.Text
      }, n.createElement(Lt, null)),
      content: function content() {
        return y.toolbar.textSelectionTool;
      },
      offset: Qt
    }),
    toggleSidebarButton: n.createElement(A, {
      position: R.BottomLeft,
      target: n.createElement(l, {
        onClick: function onClick() {
          H(!z), b();
        },
        isSelected: z
      }, n.createElement(wt, null)),
      content: function content() {
        return y.toolbar.toggleSidebar;
      },
      offset: Qt
    }),
    verticalScrollingButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return p(W.Vertical);
        },
        isSelected: s === W.Vertical
      }, n.createElement(Nt, null)),
      content: function content() {
        return y.toolbar.verticalScrolling;
      },
      offset: Qt
    }),
    zoomInButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          var e,
              t = (e = c, qt.find(function (t) {
            return t > e;
          }) || e);
          w(t);
        }
      }, n.createElement(Rt, null)),
      content: function content() {
        return y.toolbar.zoomIn;
      },
      offset: Qt
    }),
    zoomOutButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          var e = jt(c);
          w(e);
        }
      }, n.createElement(Ot, null)),
      content: function content() {
        return y.toolbar.zoomOut;
      },
      offset: Qt
    }),
    zoomPopover: n.createElement(Gt, {
      scale: c,
      onZoom: w
    }),
    wrappedScrollingButton: n.createElement(A, {
      position: R.BottomCenter,
      target: n.createElement(l, {
        onClick: function onClick() {
          return p(W.Wrapped);
        },
        isSelected: s === W.Wrapped
      }, n.createElement(ut, null)),
      content: function content() {
        return y.toolbar.wrappedScrolling;
      },
      offset: Qt
    })
  });
},
    en = new RegExp(" "),
    tn = function tn(e) {
  var r = e.defaultScale,
      a = e.doc,
      i = e.file,
      l = e.initialPage,
      c = e.keyword,
      s = e.layout,
      u = e.pageSize,
      p = e.render,
      m = e.renderPage,
      f = e.selectionMode,
      d = e.onCanvasLayerRender,
      g = e.onDocumentLoad,
      h = e.onOpenFile,
      v = e.onPageChange,
      E = e.onTextLayerRender,
      C = e.onZoom,
      x = t.useContext(o),
      b = t.useRef(null),
      w = t.useRef(null),
      k = t.useState(u.scale),
      y = k[0],
      P = k[1],
      S = t.useState(0),
      L = S[0],
      T = S[1],
      N = t.useState(0),
      R = N[0],
      O = N[1],
      F = t.useState(c ? "string" == typeof c ? new RegExp(c) : c : en),
      B = F[0],
      z = F[1],
      H = t.useState({
    matchIndex: -1,
    pageIndex: -1
  }),
      D = H[0],
      A = H[1],
      I = t.useState(W.Vertical),
      V = I[0],
      q = I[1],
      _ = t.useState(f),
      U = _[0],
      Z = _[1],
      G = function (e) {
    var n = t.useContext(o),
        r = t.useState(!1),
        a = r[0],
        i = r[1],
        l = t.useRef({
      top: 0,
      left: 0,
      x: 0,
      y: 0
    }),
        c = function c(t) {
      var n = e.current;
      n && (n.scrollTop = l.current.top - (t.clientY - l.current.y), n.scrollLeft = l.current.left - (t.clientX - l.current.x));
    },
        s = function s() {
      var t = e.current;
      t && (t.classList.add(n.prefixClass + "-grab"), t.classList.remove(n.prefixClass + "-grabbing"), document.removeEventListener("mousemove", c), document.removeEventListener("mouseup", s));
    },
        u = function u(t) {
      var r = e.current;
      a && r && (r.classList.remove(n.prefixClass + "-grab"), r.classList.add(n.prefixClass + "-grabbing"), t.preventDefault(), t.stopPropagation(), l.current = {
        left: r.scrollLeft,
        top: r.scrollTop,
        x: t.clientX,
        y: t.clientY
      }, document.addEventListener("mousemove", c), document.addEventListener("mouseup", s));
    };

    return t.useEffect(function () {
      var t = e.current;
      if (t) return a ? t.classList.add(n.prefixClass + "-grab") : t.classList.remove(n.prefixClass + "-grab"), t.addEventListener("mousedown", u), function () {
        t.removeEventListener("mousedown", u);
      };
    }, [a]), {
      toggleDragScroll: i
    };
  }(w).toggleDragScroll,
      K = $(w),
      X = K.isFullScreen,
      Y = K.openFullScreen,
      Q = K.closeFullScreen,
      ee = M(),
      te = a.numPages,
      ne = u.pageWidth,
      re = u.pageHeight,
      ae = Array(te).fill(null),
      oe = ae.map(function () {
    return 0;
  }),
      ie = ae.map(function () {
    return t.useRef();
  }),
      le = function le(e) {
    if (0 !== e.length) {
      var t,
          n,
          r = e[0];
      if ("pdf" === (t = r.name, n = t.split(/\./).pop(), n ? n.toLowerCase() : "").toLowerCase()) new Promise(function (e) {
        var t = new FileReader();
        t.readAsArrayBuffer(r), t.onload = function () {
          var n = new Uint8Array(t.result);
          e(n);
        };
      }).then(function (e) {
        h(r.name, e);
      });
    }
  },
      ce = function (e, n) {
    var r = t.useRef(0),
        a = t.useState(!1),
        o = a[0],
        i = a[1],
        l = function l(e) {
      e.preventDefault(), i(!1), r.current = 0, e.dataTransfer && n(e.dataTransfer.files);
    },
        c = function c(e) {
      e.preventDefault();
    },
        s = function s(e) {
      e.preventDefault(), r.current += 1, r.current <= 1 && i(!0);
    },
        u = function u(e) {
      e.preventDefault(), r.current -= 1, r.current <= 0 && i(!1);
    };

    return t.useEffect(function () {
      var t = e.current;
      if (t) return t.addEventListener("drop", l), t.addEventListener("dragover", c), t.addEventListener("dragenter", s), t.addEventListener("dragleave", u), function () {
        t.removeEventListener("drop", l), t.removeEventListener("dragover", c), t.removeEventListener("dragenter", s), t.removeEventListener("dragleave", u);
      };
    }, [e.current]), {
      isDragging: o
    };
  }(b, function (e) {
    return le(e);
  }).isDragging,
      se = t.useState(Xe.Inactive),
      ue = se[0],
      pe = se[1],
      me = function me(e) {
    if (!(e < 0 || e >= te)) {
      T(e);
      var t = w.current,
          n = ie[e].current;
      t && n && (t.scrollTop = n.offsetTop);
    }
  };

  t.useEffect(function () {
    g({
      doc: a
    }), l && me(l);
  }, []), t.useEffect(function () {
    v({
      currentPage: L,
      doc: a
    });
  }, [L]);

  var fe = function fe(e) {
    G(e === J.Hand), Z(e);
  },
      ge = function ge() {
    de(i.name, i.data);
  },
      he = function he(e) {
    var t = w.current;

    if (t) {
      var n = 1;

      switch (e) {
        case j.ActualSize:
          n = 1;
          break;

        case j.PageFit:
          n = Math.min((t.offsetWidth - 17) / ne, (t.offsetHeight - 16) / re);
          break;

        case j.PageWidth:
          n = (t.offsetWidth - 17) / ne;
          break;

        default:
          n = e;
      }

      P(n), C({
        doc: a,
        scale: n
      });
    }
  };

  t.useEffect(function () {
    f === J.Hand && G(!0), r && he(r);
  }, []);

  var ve = function ve(e, t) {
    oe[e] = t;
    var n = oe.reduce(function (e, t, n, r) {
      return t > r[e] ? n : e;
    }, 0);
    T(n);
  },
      Ee = function Ee(e) {
    O(360 === R || -360 === R ? e : R + e);
  },
      Ce = function Ce(e) {
    var t = w.current;

    if (t) {
      switch (e) {
        case W.Vertical:
          t.classList.add(x.prefixClass + "-inner-pages-vertical"), t.classList.remove(x.prefixClass + "-inner-pages-horizontal"), t.classList.remove(x.prefixClass + "-inner-pages-wrapped");
          break;

        case W.Horizontal:
          t.classList.add(x.prefixClass + "-inner-pages-horizontal"), t.classList.remove(x.prefixClass + "-inner-pages-vertical"), t.classList.remove(x.prefixClass + "-inner-pages-wrapped");
          break;

        case W.Wrapped:
          t.classList.add(x.prefixClass + "-inner-pages-wrapped"), t.classList.remove(x.prefixClass + "-inner-pages-vertical"), t.classList.remove(x.prefixClass + "-inner-pages-horizontal");
      }

      q(e);
    }
  },
      xe = function xe(e) {
    me(e.pageIndex), A(e);
  },
      be = function be(e, t, n) {
    var r = w.current;

    if (r) {
      var o = e + 1;
      a.getPage(o).then(function (a) {
        var o = a.getViewport({
          scale: 1
        }),
            i = 0,
            l = t || 0;

        switch (n) {
          case j.PageFit:
            i = 0, he(j.PageFit);
            break;

          default:
            i = (o.height - l) * y;
        }

        var c = ie[e].current;
        c && (r.scrollTop = c.offsetTop + i);
      });
    }
  },
      we = function we(e) {
    var t = L - 1,
        n = L + 1;

    switch (e) {
      case "FirstPage":
        me(0);
        break;

      case "LastPage":
        me(te - 1);
        break;

      case "NextPage":
        n < te && me(n);
        break;

      case "PrevPage":
        t >= 0 && me(t);
    }
  },
      ke = function ke() {
    return pe(Xe.Preparing);
  };

  return p({
    viewer: s(ee.opened, {
      attrs: {
        ref: b,
        style: {
          position: "relative"
        }
      },
      children: n.createElement(n.Fragment, null, n.createElement(et, {
        doc: a,
        pageHeight: re,
        pageWidth: ne,
        printStatus: ue,
        rotation: R,
        onCancel: function onCancel() {
          return pe(Xe.Inactive);
        },
        onStartPrinting: function onStartPrinting() {
          return pe(Xe.Ready);
        }
      }), ce && n.createElement(Ze, null))
    }, {
      attrs: {
        ref: w,
        style: {
          position: "relative"
        }
      },
      children: n.createElement(n.Fragment, null, X && n.createElement(nt, {
        onClick: Q
      }), Array(te).fill(0).map(function (e, t) {
        return n.createElement("div", {
          className: x.prefixClass + "-inner-page",
          key: "pagelayer-" + t,
          ref: function ref(e) {
            ie[t].current = e;
          }
        }, n.createElement(_e, {
          doc: a,
          keywordRegexp: B,
          height: re,
          match: D,
          pageIndex: t,
          renderPage: m,
          rotation: R,
          scale: y,
          width: ne,
          onCanvasLayerRender: d,
          onExecuteNamedAction: we,
          onJumpToDest: be,
          onPageVisibilityChanged: ve,
          onTextLayerRender: E
        }));
      }))
    }, function (e) {
      return n.createElement($t, {
        currentPage: L,
        doc: a,
        fileName: i.name,
        scale: y,
        scrollMode: V,
        selectionMode: U,
        onChangeScrollMode: Ce,
        onChangeSelectionMode: fe,
        onDownload: ge,
        onFullScreen: Y,
        onJumpTo: me,
        onJumpToMatch: xe,
        onOpenFiles: le,
        onPrint: ke,
        onRotate: Ee,
        onSearchFor: z,
        onToggleSidebar: ee.toggle,
        onZoom: he,
        renderToolbar: e
      });
    }, {
      attrs: {},
      children: n.createElement(gt, {
        currentPage: L,
        doc: a,
        height: re,
        rotation: R,
        width: ne,
        onJumpToDest: be,
        onJumpToPage: me
      })
    }),
    doc: a,
    download: ge,
    changeScrollMode: Ce,
    changeSelectionMode: fe,
    jumpToPage: me,
    print: ke,
    rotate: Ee,
    zoom: he
  });
},
    nn = function nn(e) {
  var r = e.doc,
      a = e.render,
      i = t.useContext(o),
      l = t.useRef(null),
      c = t.useState({
    pageHeight: 0,
    pageWidth: 0,
    scale: 1
  }),
      s = c[0],
      u = c[1];
  return t.useEffect(function () {
    r.getPage(1).then(function (e) {
      var t = e.getViewport({
        scale: 1
      }),
          n = t.width,
          r = t.height,
          a = l.current;

      if (a) {
        var o = a.offsetWidth / n,
            i = jt(Math.max(1, o));
        u({
          pageHeight: r,
          pageWidth: n,
          scale: i
        });
      }
    });
  }, [r]), 0 === s.pageWidth ? n.createElement("div", {
    className: i.prefixClass + "-page-size-calculator",
    ref: l
  }, n.createElement(g, null)) : a(s);
},
    rn = function rn() {},
    an = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.verifyPasswordFn = t, n;
  }

  return v(t, e), t;
}(rn),
    on = function on(e) {
  var r = e.verifyPasswordFn,
      a = t.useContext(Ue),
      i = t.useContext(o),
      l = t.useState(""),
      c = l[0],
      s = l[1];
  return n.createElement("div", {
    className: i.prefixClass + "-asking-password"
  }, n.createElement("div", null, n.createElement("div", {
    className: i.prefixClass + "-asking-password-message"
  }, a.askingPassword.requirePasswordToOpen, ":"), n.createElement("div", {
    className: i.prefixClass + "-asking-password-input-container"
  }, n.createElement("input", {
    className: i.prefixClass + "-asking-password-input",
    type: "password",
    onChange: function onChange(e) {
      return s(e.target.value);
    }
  }), n.createElement("button", {
    className: i.prefixClass + "-asking-password-button",
    onClick: function onClick() {
      return r(c);
    }
  }, a.askingPassword.submit))));
},
    ln = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.doc = t, n;
  }

  return v(t, e), t;
}(rn),
    cn = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.error = t, n;
  }

  return v(t, e), t;
}(rn),
    sn = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.percentages = t, n;
  }

  return v(t, e), t;
}(rn),
    un = function un(e) {
  var r = e.verifyPasswordFn,
      a = t.useContext(Ue),
      i = t.useContext(o),
      l = t.useState(""),
      c = l[0],
      s = l[1];
  return n.createElement("div", {
    className: i.prefixClass + "-asking-password"
  }, n.createElement("div", null, n.createElement("div", {
    className: i.prefixClass + "-asking-password-message"
  }, a.wrongPassword.tryAgain, ":"), n.createElement("div", {
    className: i.prefixClass + "-asking-password-input-container"
  }, n.createElement("input", {
    className: i.prefixClass + "-asking-password-input",
    type: "password",
    onChange: function onChange(e) {
      return s(e.target.value);
    }
  }), n.createElement("button", {
    className: i.prefixClass + "-asking-password-button",
    onClick: function onClick() {
      return r(c);
    }
  }, a.wrongPassword.submit))));
},
    pn = function (e) {
  function t(t) {
    var n = e.call(this) || this;
    return n.verifyPasswordFn = t, n;
  }

  return v(t, e), t;
}(rn),
    mn = function mn(e) {
  var a = e.characterMap,
      i = e.file,
      l = e.render,
      c = e.renderError,
      s = t.useContext(o),
      u = t.useState(new sn(0)),
      p = u[0],
      m = u[1];

  switch (t.useEffect(function () {
    m(new sn(0));
    var e = Object.assign({}, "string" == typeof i ? {
      url: i
    } : {
      data: i
    }, a ? {
      cMapUrl: a.url,
      cMapPacked: a.isCompressed
    } : {}),
        t = r.getDocument(e);
    return t.onPassword = function (e, t) {
      switch (t) {
        case r.PasswordResponses.NEED_PASSWORD:
          m(new an(e));
          break;

        case r.PasswordResponses.INCORRECT_PASSWORD:
          m(new pn(e));
      }
    }, t.promise.then(function (e) {
      return m(new ln(e));
    }, function (e) {
      return m(new cn({
        message: e.message || "Cannot load document",
        name: e.name
      }));
    }), function () {
      t.destroy();
    };
  }, [i]), !0) {
    case p instanceof an:
      return n.createElement(on, {
        verifyPasswordFn: p.verifyPasswordFn
      });

    case p instanceof pn:
      return n.createElement(un, {
        verifyPasswordFn: p.verifyPasswordFn
      });

    case p instanceof ln:
      return l(p.doc);

    case p instanceof cn:
      return c ? c(p.error) : n.createElement("div", {
        className: s.prefixClass + "-doc-error"
      }, n.createElement("div", {
        className: s.prefixClass + "-doc-error-text"
      }, p.error.message));

    case p instanceof sn:
    default:
      return n.createElement("div", {
        className: s.prefixClass + "-doc-loading"
      }, n.createElement(g, null));
  }
},
    fn = {
  askingPassword: {
    requirePasswordToOpen: "This document requires a password to open",
    submit: "Submit"
  },
  attachment: {
    clickToDownload: "Click to download",
    noAttachment: "There is no attachment"
  },
  bookmark: {
    noBookmark: "There is no bookmark"
  },
  main: {
    dragDropFile: "Drag and drop a PDF document here"
  },
  printProgress: {
    cancel: "Cancel",
    preparingDocument: "Preparing document ..."
  },
  property: {
    author: "Author",
    close: "Close",
    creationDate: "Creation date",
    creator: "Creator",
    fileName: "File name",
    fileSize: "File size",
    keywords: "Keywords",
    modificationDate: "Modification date",
    pageCount: "Page count",
    pdfProducer: "PDF producer",
    pdfVersion: "PDF Version",
    subject: "Subject",
    title: "Title"
  },
  search: {
    close: "Close",
    enterToSearch: "Enter to search",
    matchCase: "Match case",
    nextMatch: "Next match",
    previousMatch: "Previous match",
    wholeWords: "Whole words"
  },
  sidebar: {
    attachment: "Attachment",
    bookmark: "Bookmark",
    thumbnail: "Thumbnail"
  },
  toolbar: {
    documentProperties: "Document properties",
    download: "Download",
    fullScreen: "Full screen",
    goToFirstPage: "Go to first page",
    goToLastPage: "Go to last page",
    handTool: "Hand tool",
    horizontalScrolling: "Horizontal scrolling",
    moreActions: "More actions",
    nextPage: "Next page",
    openFile: "Open file",
    previousPage: "Previous page",
    print: "Print",
    rotateBackward: "Rotate counterclockwise",
    rotateForward: "Rotate clockwise",
    search: "Search",
    textSelectionTool: "Text selection tool",
    toggleSidebar: "Toggle sidebar",
    verticalScrolling: "Vertical scrolling",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    wrappedScrolling: "Wrapped scrolling"
  },
  wrongPassword: {
    submit: "Submit",
    tryAgain: "The password is wrong. Please try again"
  },
  zoom: {
    actualSize: "Actual size",
    pageFit: "Page fit",
    pageWidth: "Page width"
  }
},
    dn = function dn(e) {
  var t = e.children,
      r = e.localization || fn;
  return n.createElement(Ue.Provider, {
    value: r
  }, t);
},
    gn = function gn(e) {
  var t = e.children,
      r = e.prefixClass;
  return n.createElement(o.Provider, {
    value: {
      prefixClass: r || "viewer"
    }
  }, t);
};

exports.Button = l, exports.Icon = s, exports.MenuDivider = c, exports.MenuItem = p, exports.Modal = T, exports.Popover = H, exports.Position = R, exports.PrimaryButton = m, exports.ProgressBar = f, exports.ScrollMode = W, exports.SelectionMode = J, exports.Separator = d, exports.SpecialZoomLevel = j, exports.Spinner = g, exports.Tooltip = A, exports.Worker = function (e) {
  var t = e.children,
      a = e.workerUrl;
  return r.GlobalWorkerOptions.workerSrc = a, n.createElement(n.Fragment, null, t);
}, exports.default = function (e) {
  var r = e.characterMap,
      a = e.defaultScale,
      o = e.fileUrl,
      i = e.initialPage,
      l = e.keyword,
      c = e.layout,
      s = e.localization,
      u = e.prefixClass,
      p = e.render,
      m = e.renderError,
      f = e.renderPage,
      d = e.selectionMode,
      g = void 0 === d ? J.Text : d,
      h = e.onCanvasLayerRender,
      v = void 0 === h ? function () {} : h,
      E = e.onDocumentLoad,
      C = void 0 === E ? function () {} : E,
      w = e.onPageChange,
      k = void 0 === w ? function () {} : w,
      y = e.onTextLayerRender,
      P = void 0 === y ? function () {} : y,
      S = e.onZoom,
      M = void 0 === S ? function () {} : S,
      L = t.useState({
    data: o,
    name: "string" == typeof o ? o : ""
  }),
      T = L[0],
      N = L[1],
      R = function R(e, t, n, r, a) {
    return x(e, t, n, r(b), a);
  },
      O = function O(e, t) {
    N({
      data: t,
      name: e
    });
  };

  t.useEffect(function () {
    N({
      data: o,
      name: "string" == typeof o ? o : ""
    });
  }, [o]);

  var F,
      B = p || function (e) {
    return e.viewer;
  };

  return n.createElement(gn, {
    prefixClass: u
  }, n.createElement(dn, {
    localization: s
  }, n.createElement(mn, {
    characterMap: r,
    file: T.data,
    render: (F = B, function (e) {
      return n.createElement(nn, {
        doc: e,
        render: function render(t) {
          var r = t;
          return n.createElement(tn, {
            defaultScale: a,
            doc: e,
            file: T,
            initialPage: i,
            keyword: l,
            layout: c || R,
            pageSize: r,
            render: F,
            renderPage: f,
            selectionMode: g,
            onCanvasLayerRender: v,
            onDocumentLoad: C,
            onOpenFile: O,
            onPageChange: k,
            onTextLayerRender: P,
            onZoom: M
          });
        }
      });
    }),
    renderError: m
  })));
}, exports.defaultLayout = x, exports.defaultToolbar = b;